import React from "react";

import Main from "../layouts/main";

export default function(props) {
  return (
    <Main title="Rates" subTitle="Lowest rates in the world!" {...props}>
      <table width="1022" border="0" cellSpacing="0" cellPadding="0">
        <colgroup>
          <col width="341" />
          <col width="113" />
          <col width="206" />
          <col width="249" />
          <col width="113" />
        </colgroup>
        <tbody>
          <tr>
            <td className="xl64" width="341" height="20">
              Country
            </td>
            <td className="xl64" width="113">
              Code
            </td>
            <td className="xl64" width="206">
              Initial Rate per Minute
            </td>
            <td className="xl64" width="249">
              Increment Rate Per Minute
            </td>
            <td className="xl64" width="113">
              Time Of Day
            </td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Afghanistan
            </td>
            <td className="xl66" align="right">
              93
            </td>
            <td className="xl67">0.45</td>
            <td className="xl67">0.45</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Afghanistan-Mobile
            </td>
            <td className="xl69" align="right">
              937
            </td>
            <td className="xl70">0.45</td>
            <td className="xl70">0.45</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Afghanistan-Mobile Etisalat
            </td>
            <td className="xl66" align="right">
              9378
            </td>
            <td className="xl67">0.45</td>
            <td className="xl67">0.45</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Albania
            </td>
            <td className="xl69" align="right">
              355
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Albania Mobile Eagle
            </td>
            <td className="xl66" align="right">
              35567
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Albania-Mobile
            </td>
            <td className="xl69" align="right">
              35568
            </td>
            <td className="xl70">0.25</td>
            <td className="xl70">0.25</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Albania-Mobile Vodafone
            </td>
            <td className="xl66" align="right">
              35569
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Albania-Tirana
            </td>
            <td className="xl69" align="right">
              3554
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Algeria
            </td>
            <td className="xl66" align="right">
              213
            </td>
            <td className="xl67">0.19</td>
            <td className="xl67">0.19</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Algeria-Algiers
            </td>
            <td className="xl69" align="right">
              21321
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Algeria-Mobile
            </td>
            <td className="xl66" align="right">
              2136
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Algeria-Mobile Djezzy
            </td>
            <td className="xl69" align="right">
              21377
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Algeria-Mobile Wataniya
            </td>
            <td className="xl66" align="right">
              2135
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>

          <tr>
            <td className="xl69" height="17">
              American Samoa
            </td>
            <td className="xl69" align="right">
              684
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Andorra
            </td>
            <td className="xl66" align="right">
              376
            </td>
            <td className="xl67">0.07</td>
            <td className="xl67">0.07</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Andorra-Mobile
            </td>
            <td className="xl69" align="right">
              3763
            </td>
            <td className="xl70">0.29</td>
            <td className="xl70">0.29</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Angola
            </td>
            <td className="xl66" align="right">
              244
            </td>
            <td className="xl67">0.18</td>
            <td className="xl67">0.18</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Angola-Mobile
            </td>
            <td className="xl69" align="right">
              2449
            </td>
            <td className="xl70">0.25</td>
            <td className="xl70">0.25</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Anguilla
            </td>
            <td className="xl66" align="right">
              1264
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Anguilla C&amp;W Mobile
            </td>
            <td className="xl69" align="right">
              1264235
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Anguilla-Mobile
            </td>
            <td className="xl66" align="right">
              1264536
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Anguilla-Mobile Digicel
            </td>
            <td className="xl69" align="right">
              1264581
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Antarctica
            </td>
            <td className="xl66" align="right">
              672
            </td>
            <td className="xl67">0.35</td>
            <td className="xl67">0.35</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Antigua
            </td>
            <td className="xl69" align="right">
              1268
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Antigua C&amp;W Mobile
            </td>
            <td className="xl66" align="right">
              1268464
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Antigua-Mobile
            </td>
            <td className="xl69" align="right">
              1268404
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina
            </td>
            <td className="xl66" align="right">
              54
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina Cellular-Domestic
            </td>
            <td className="xl69" align="right">
              541115
            </td>
            <td className="xl70">0.27</td>
            <td className="xl70">0.27</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina Clave 1
            </td>
            <td className="xl66" align="right">
              54220
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina Clave 2
            </td>
            <td className="xl69" align="right">
              542225
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina Clave 3
            </td>
            <td className="xl66" align="right">
              542221
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina Clave 4
            </td>
            <td className="xl69" align="right">
              542241
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina Clave 5
            </td>
            <td className="xl66" align="right">
              542245
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina Clave 6
            </td>
            <td className="xl69" align="right">
              542246
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina Clave 7
            </td>
            <td className="xl66" align="right">
              542255
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina Emergency Numbers
            </td>
            <td className="xl69" align="right">
              5.41144E+11
            </td>
            <td className="xl70">0.04</td>
            <td className="xl70">0.04</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina Toll-Free
            </td>
            <td className="xl66" align="right">
              54800
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina-Buenos Aires
            </td>
            <td className="xl69" align="right">
              5411
            </td>
            <td className="xl70">0.04</td>
            <td className="xl70">0.04</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina-Cordoba
            </td>
            <td className="xl66" align="right">
              54351
            </td>
            <td className="xl67">0.04</td>
            <td className="xl67">0.04</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina-Gral Pico
            </td>
            <td className="xl69" align="right">
              542302
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina-La Pampa
            </td>
            <td className="xl66" align="right">
              542954
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina-La Plata
            </td>
            <td className="xl69" align="right">
              54221
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina-Local Cities
            </td>
            <td className="xl66" align="right">
              54291
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina-Mar Del Plata
            </td>
            <td className="xl69" align="right">
              54223
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina-Mendoza
            </td>
            <td className="xl66" align="right">
              54261
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina-Mobile
            </td>
            <td className="xl69" align="right">
              549
            </td>
            <td className="xl70">0.27</td>
            <td className="xl70">0.27</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina-Moreno
            </td>
            <td className="xl66" align="right">
              542337
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina-Neuquen
            </td>
            <td className="xl69" align="right">
              54299
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina-Pergamino
            </td>
            <td className="xl66" align="right">
              542477
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina-Rosario
            </td>
            <td className="xl69" align="right">
              54341
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Argentina-San Juan
            </td>
            <td className="xl66" align="right">
              54264
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Argentina-San Luis
            </td>
            <td className="xl69" align="right">
              542652
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Armenia
            </td>
            <td className="xl66" align="right">
              374
            </td>
            <td className="xl67">0.11</td>
            <td className="xl67">0.11</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Armenia-Mobile
            </td>
            <td className="xl69" align="right">
              3749
            </td>
            <td className="xl70">0.3</td>
            <td className="xl70">0.3</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Armenia-Yerevan
            </td>
            <td className="xl66" align="right">
              3741
            </td>
            <td className="xl67">0.08</td>
            <td className="xl67">0.08</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Aruba
            </td>
            <td className="xl69" align="right">
              297
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Aruba-Mobile
            </td>
            <td className="xl66" align="right">
              29756
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ascension Island
            </td>
            <td className="xl69" align="right">
              247
            </td>
            <td className="xl70">0.72</td>
            <td className="xl70">0.72</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Atlantic Ocean
            </td>
            <td className="xl66" align="right">
              871
            </td>
            <td className="xl67">2.35</td>
            <td className="xl67">2.35</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Atlantic West
            </td>
            <td className="xl69" align="right">
              874
            </td>
            <td className="xl70">4</td>
            <td className="xl70">4</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Australia
            </td>
            <td className="xl66" align="right">
              61
            </td>
            <td className="xl67">0.03</td>
            <td className="xl67">0.03</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Australia-Christmas Island
            </td>
            <td className="xl69" align="right">
              61891008
            </td>
            <td className="xl70">0.03</td>
            <td className="xl70">0.03</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Australia-Cocos Islands
            </td>
            <td className="xl66" align="right">
              6189162
            </td>
            <td className="xl67">0.03</td>
            <td className="xl67">0.03</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Australia-Mobile
            </td>
            <td className="xl69" align="right">
              614
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Australia-Mobile-Satellite
            </td>
            <td className="xl66" align="right">
              611
            </td>
            <td className="xl67">0.03</td>
            <td className="xl67">0.03</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Australia-Sydney
            </td>
            <td className="xl69" align="right">
              6128
            </td>
            <td className="xl70">0.03</td>
            <td className="xl70">0.03</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Austria
            </td>
            <td className="xl66" align="right">
              43
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Austria Mobile Other
            </td>
            <td className="xl69" align="right">
              43651
            </td>
            <td className="xl70">0.24</td>
            <td className="xl70">0.24</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Austria Special Services
            </td>
            <td className="xl66" align="right">
              4350
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Austria-Mobile A1
            </td>
            <td className="xl69" align="right">
              43664
            </td>
            <td className="xl70">0.24</td>
            <td className="xl70">0.24</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Austria-Mobile Hutchinson
            </td>
            <td className="xl66" align="right">
              43660
            </td>
            <td className="xl67">0.24</td>
            <td className="xl67">0.24</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Austria-Mobile Mobile One
            </td>
            <td className="xl69" align="right">
              43699
            </td>
            <td className="xl70">0.24</td>
            <td className="xl70">0.24</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Austria-Mobile Tele2
            </td>
            <td className="xl66" align="right">
              436888
            </td>
            <td className="xl67">0.24</td>
            <td className="xl67">0.24</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Austria-Mobile Telering
            </td>
            <td className="xl69" align="right">
              43650
            </td>
            <td className="xl70">0.29</td>
            <td className="xl70">0.29</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Austria-Mobile Tmobile
            </td>
            <td className="xl66" align="right">
              43676
            </td>
            <td className="xl67">0.24</td>
            <td className="xl67">0.24</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Austria-Vienna
            </td>
            <td className="xl69" align="right">
              431
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Azerbaijan
            </td>
            <td className="xl66" align="right">
              994
            </td>
            <td className="xl67">0.18</td>
            <td className="xl67">0.18</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Azerbaijan-Baku
            </td>
            <td className="xl69" align="right">
              99412
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Azerbaijan-Mobile
            </td>
            <td className="xl66" align="right">
              99450
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bahamas
            </td>
            <td className="xl69" align="right">
              1242
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bahamas-Mobile
            </td>
            <td className="xl66" align="right">
              1242357
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bahrain
            </td>
            <td className="xl69" align="right">
              973
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bahrain-Mobile
            </td>
            <td className="xl66" align="right">
              9733
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bahrain-Mobile Zain
            </td>
            <td className="xl69" align="right">
              97336
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bangladesh
            </td>
            <td className="xl66" align="right">
              880
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bangladesh-Chittagong
            </td>
            <td className="xl69" align="right">
              88031
            </td>
            <td className="xl70">0.16</td>
            <td className="xl70">0.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bangladesh-Dhaka
            </td>
            <td className="xl66" align="right">
              8802
            </td>
            <td className="xl67">0.08</td>
            <td className="xl67">0.08</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bangladesh-Mobile
            </td>
            <td className="xl69" align="right">
              8801
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bangladesh-Mobile Aktel
            </td>
            <td className="xl66" align="right">
              88018
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bangladesh-Mobile Grameen
            </td>
            <td className="xl69" align="right">
              88017
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bangladesh-Syhlet
            </td>
            <td className="xl66" align="right">
              880821
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Barbados
            </td>
            <td className="xl69" align="right">
              1246
            </td>
            <td className="xl70">0.16</td>
            <td className="xl70">0.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Barbados-C&amp;W Mobile
            </td>
            <td className="xl66" align="right">
              124623
            </td>
            <td className="xl67">0.26</td>
            <td className="xl67">0.26</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Barbados-Mobile
            </td>
            <td className="xl69" align="right">
              124625
            </td>
            <td className="xl70">0.26</td>
            <td className="xl70">0.26</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Barbados-Mobile Digicel
            </td>
            <td className="xl66" align="right">
              124626
            </td>
            <td className="xl67">0.26</td>
            <td className="xl67">0.26</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Belarus
            </td>
            <td className="xl69" align="right">
              375
            </td>
            <td className="xl70">0.25</td>
            <td className="xl70">0.25</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Belarus Premium
            </td>
            <td className="xl66" align="right">
              375602
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Belarus-Minsk
            </td>
            <td className="xl69" align="right">
              375172
            </td>
            <td className="xl70">0.24</td>
            <td className="xl70">0.24</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Belarus-Mobile
            </td>
            <td className="xl66" align="right">
              37529
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Belgium
            </td>
            <td className="xl69" align="right">
              32
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Belgium-Mobile
            </td>
            <td className="xl66" align="right">
              3248
            </td>
            <td className="xl67">0.29</td>
            <td className="xl67">0.29</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Belgium-Mobile Movistar
            </td>
            <td className="xl69" align="right">
              3249
            </td>
            <td className="xl70">0.29</td>
            <td className="xl70">0.29</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Belgium-Mobile Proximus
            </td>
            <td className="xl66" align="right">
              3247
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Belgium-Premium
            </td>
            <td className="xl69" align="right">
              3244
            </td>
            <td className="xl70">0.29</td>
            <td className="xl70">0.29</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Belize
            </td>
            <td className="xl66" align="right">
              501
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Belize-Mobile
            </td>
            <td className="xl69" align="right">
              5016
            </td>
            <td className="xl70">0.29</td>
            <td className="xl70">0.29</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Benin
            </td>
            <td className="xl66" align="right">
              229
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Benin-Mobile
            </td>
            <td className="xl69" align="right">
              2299
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bermuda
            </td>
            <td className="xl66" align="right">
              1441
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bermuda-Mobile
            </td>
            <td className="xl69" align="right">
              14413
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bhutan
            </td>
            <td className="xl66" align="right">
              975
            </td>
            <td className="xl67">0.19</td>
            <td className="xl67">0.19</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bolivia
            </td>
            <td className="xl69" align="right">
              591
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bolivia Cellular-Entel
            </td>
            <td className="xl66" align="right">
              59171
            </td>
            <td className="xl67">0.14</td>
            <td className="xl67">0.14</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bolivia Mobile-Nuevatel
            </td>
            <td className="xl69" align="right">
              59170
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bolivia Mobile-Telecel
            </td>
            <td className="xl66" align="right">
              59177
            </td>
            <td className="xl67">0.14</td>
            <td className="xl67">0.14</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bolivia-Cochabamba
            </td>
            <td className="xl69" align="right">
              59144
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bolivia-La Paz
            </td>
            <td className="xl66" align="right">
              59122
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bolivia-Mobile
            </td>
            <td className="xl69" align="right">
              5917
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bolivia-Santa Cruz
            </td>
            <td className="xl66" align="right">
              59133
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bosnia And Herzegovina
            </td>
            <td className="xl69" align="right">
              387
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bosnia And Herzegovina-Mobile
            </td>
            <td className="xl66" align="right">
              3876
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Botswana
            </td>
            <td className="xl69" align="right">
              267
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Botswana-Mobile
            </td>
            <td className="xl66" align="right">
              26771
            </td>
            <td className="xl67">0.34</td>
            <td className="xl67">0.34</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brazil
            </td>
            <td className="xl69" align="right">
              55
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Brazil-0800
            </td>
            <td className="xl66" align="right">
              55000800
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brazil-Belem
            </td>
            <td className="xl69" align="right">
              5591
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Brazil-Belo Horizonte
            </td>
            <td className="xl66" align="right">
              5531
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brazil-Brasilia
            </td>
            <td className="xl69" align="right">
              5561
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Brazil-Campinas
            </td>
            <td className="xl66" align="right">
              5519
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brazil-Curitiba
            </td>
            <td className="xl69" align="right">
              5541
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Brazil-Fortaleza
            </td>
            <td className="xl66" align="right">
              5585
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brazil-Goiania
            </td>
            <td className="xl69" align="right">
              5562
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Brazil-Governador Valadares
            </td>
            <td className="xl66" align="right">
              5533
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brazil-Mobile
            </td>
            <td className="xl69" align="right">
              55009
            </td>
            <td className="xl70">0.289</td>
            <td className="xl70">0.289</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Brazil-Mobile (Telemar Pcs)
            </td>
            <td className="xl66" align="right">
              552286
            </td>
            <td className="xl67">0.289</td>
            <td className="xl67">0.289</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brazil-Mobile Oi
            </td>
            <td className="xl69" align="right">
              552186
            </td>
            <td className="xl70">0.289</td>
            <td className="xl70">0.289</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Brazil-Porto Alegre
            </td>
            <td className="xl66" align="right">
              5551
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brazil-Recife
            </td>
            <td className="xl69" align="right">
              5581
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Brazil-Rio De Janeiro
            </td>
            <td className="xl66" align="right">
              5521
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brazil-Salvador
            </td>
            <td className="xl69" align="right">
              5571
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Brazil-Sao Jose Dos Campos
            </td>
            <td className="xl66" align="right">
              5512
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brazil-Sao Paulo
            </td>
            <td className="xl69" align="right">
              5511
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Brazil-Sjc Local
            </td>
            <td className="xl66" align="right">
              55123009
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brazil-Vitoria
            </td>
            <td className="xl69" align="right">
              5527
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              British Virgin Islands
            </td>
            <td className="xl66" align="right">
              1284
            </td>
            <td className="xl67">0.14</td>
            <td className="xl67">0.14</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              British Virgin Islands-C&amp;W Mobile
            </td>
            <td className="xl69" align="right">
              1284540
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              British Virgin Islands-Mobile
            </td>
            <td className="xl66" align="right">
              1284440
            </td>
            <td className="xl67">0.14</td>
            <td className="xl67">0.14</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Brunei
            </td>
            <td className="xl69" align="right">
              673
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Brunei-Mobile
            </td>
            <td className="xl66" align="right">
              6738
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bulgaria
            </td>
            <td className="xl69" align="right">
              359
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bulgaria-Mobile
            </td>
            <td className="xl66" align="right">
              35989
            </td>
            <td className="xl67">0.33</td>
            <td className="xl67">0.33</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bulgaria-Mobile Mobikom
            </td>
            <td className="xl69" align="right">
              35948
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bulgaria-Mobile Mobitel
            </td>
            <td className="xl66" align="right">
              35988
            </td>
            <td className="xl67">0.33</td>
            <td className="xl67">0.33</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Bulgaria-On-Net
            </td>
            <td className="xl69" align="right">
              35932
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Bulgaria-Sofia
            </td>
            <td className="xl66" align="right">
              3592
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Burkina Faso
            </td>
            <td className="xl69" align="right">
              226
            </td>
            <td className="xl70">0.16</td>
            <td className="xl70">0.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Burkina Faso Mobile
            </td>
            <td className="xl66" align="right">
              2267
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Burma(Myanmar)
            </td>
            <td className="xl69" align="right">
              95
            </td>
            <td className="xl70">0.39</td>
            <td className="xl70">0.39</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Burundi
            </td>
            <td className="xl66" align="right">
              257
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Burundi-Mobile
            </td>
            <td className="xl69" align="right">
              25729
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Cambodia
            </td>
            <td className="xl66" align="right">
              855
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cambodia-Mobile
            </td>
            <td className="xl69" align="right">
              8551
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Cameroon
            </td>
            <td className="xl66" align="right">
              237
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cameroon-Mobile Mtn
            </td>
            <td className="xl69" align="right">
              2377
            </td>
            <td className="xl70">0.25</td>
            <td className="xl70">0.25</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Cameroon-Mobile Orange
            </td>
            <td className="xl66" align="right">
              2379
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Canada
            </td>
            <td className="xl69" align="right">
              1778
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Canada-1403
            </td>
            <td className="xl66" align="right">
              1403
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Canada-1416
            </td>
            <td className="xl69" align="right">
              1416
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Canada-1514
            </td>
            <td className="xl66" align="right">
              1514
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Canada-1604
            </td>
            <td className="xl69" align="right">
              1604
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Canada-1647
            </td>
            <td className="xl66" align="right">
              1647
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Canada-1905
            </td>
            <td className="xl69" align="right">
              1905
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Canada-Yukon
            </td>
            <td className="xl66" align="right">
              1867
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cape Verde Islands
            </td>
            <td className="xl69" align="right">
              238
            </td>
            <td className="xl70">0.34</td>
            <td className="xl70">0.34</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Cape Verde Islands-Mobile
            </td>
            <td className="xl66" align="right">
              2389
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cayman Islands
            </td>
            <td className="xl69" align="right">
              1345
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Cayman Islands-C&amp;W Mobile
            </td>
            <td className="xl66" align="right">
              1345917
            </td>
            <td className="xl67">0.4</td>
            <td className="xl67">0.4</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cayman Islands-Cayonef
            </td>
            <td className="xl69" align="right">
              1345626
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Cayman Islands-Cayonem
            </td>
            <td className="xl66" align="right">
              1345229
            </td>
            <td className="xl67">0.18</td>
            <td className="xl67">0.18</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cayman Islands-Digif
            </td>
            <td className="xl69" align="right">
              1345623
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Cayman Islands-Mobile
            </td>
            <td className="xl66" align="right">
              1345326
            </td>
            <td className="xl67">0.4</td>
            <td className="xl67">0.4</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cayman Islands-Mobile Atw
            </td>
            <td className="xl69" align="right">
              1345514
            </td>
            <td className="xl70">0.4</td>
            <td className="xl70">0.4</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Cayman Islands-Mobile Digicel
            </td>
            <td className="xl66" align="right">
              1345325
            </td>
            <td className="xl67">0.4</td>
            <td className="xl67">0.4</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Central Africa Republic Mobile
            </td>
            <td className="xl69" align="right">
              2360
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Central Africa Republic Mobile Acell
            </td>
            <td className="xl66" align="right">
              23670
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Central Africa Republic Mobile Nationlink
            </td>
            <td className="xl69" align="right">
              23677
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Central Africa Republic Mobile-Orange
            </td>
            <td className="xl66" align="right">
              23672
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Central Africa Republic Mobile-Telecel
            </td>
            <td className="xl69" align="right">
              23675
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Central African Republic
            </td>
            <td className="xl66" align="right">
              236
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Chad
            </td>
            <td className="xl69" align="right">
              235
            </td>
            <td className="xl70">0.28</td>
            <td className="xl70">0.28</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Chad Mobile
            </td>
            <td className="xl66" align="right">
              2352
            </td>
            <td className="xl67">0.28</td>
            <td className="xl67">0.28</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Chad Mobile-Celtel
            </td>
            <td className="xl69" align="right">
              2353
            </td>
            <td className="xl70">0.28</td>
            <td className="xl70">0.28</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Chile
            </td>
            <td className="xl66" align="right">
              56
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Chile-Mobile
            </td>
            <td className="xl69" align="right">
              569
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Chile-Rural
            </td>
            <td className="xl66" align="right">
              567919
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Chile-Santiago
            </td>
            <td className="xl69" align="right">
              562
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              China
            </td>
            <td className="xl66" align="right">
              86
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              China-Beijing
            </td>
            <td className="xl69" align="right">
              8610
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              China-Mobile
            </td>
            <td className="xl66" align="right">
              8613
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              China-Shanghai
            </td>
            <td className="xl69" align="right">
              8621
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Colombia
            </td>
            <td className="xl66" align="right">
              57
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Colombia Mobile-Movistar
            </td>
            <td className="xl69" align="right">
              57315
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Colombia Mobile-Ola
            </td>
            <td className="xl66" align="right">
              57300
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>

          <tr>
            <td className="xl69" height="17">
              Colombia-Barranquilla
            </td>
            <td className="xl69" align="right">
              5753
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Colombia-Bogota
            </td>
            <td className="xl66" align="right">
              5712
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Colombia-Bucaramanga
            </td>
            <td className="xl69" align="right">
              57763
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Colombia-Cali
            </td>
            <td className="xl66" align="right">
              5723
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Colombia-Lex Telecom
            </td>
            <td className="xl69" align="right">
              5718230
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Colombia-Medellin
            </td>
            <td className="xl66" align="right">
              5742
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Colombia-Mobile
            </td>
            <td className="xl69" align="right">
              573
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Colombia-Mobile-Comcel
            </td>
            <td className="xl66" align="right">
              57310
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Colombia-Pereira
            </td>
            <td className="xl69" align="right">
              57631
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Comoros
            </td>
            <td className="xl66" align="right">
              269
            </td>
            <td className="xl67">0.45</td>
            <td className="xl67">0.45</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Comoros-Grand-Comore
            </td>
            <td className="xl69" align="right">
              2697
            </td>
            <td className="xl70">0.45</td>
            <td className="xl70">0.45</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Comoros-Mobile
            </td>
            <td className="xl66" align="right">
              2693
            </td>
            <td className="xl67">0.45</td>
            <td className="xl67">0.45</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Congo
            </td>
            <td className="xl69" align="right">
              242
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Congo Mobile Mtn
            </td>
            <td className="xl66" align="right">
              24206
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Congo Mobile Warid
            </td>
            <td className="xl69" align="right">
              2424
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Congo Mobile-Zain
            </td>
            <td className="xl66" align="right">
              2425
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cook Islands
            </td>
            <td className="xl69" align="right">
              682
            </td>
            <td className="xl70">1</td>
            <td className="xl70">1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Costa Rica
            </td>
            <td className="xl66" align="right">
              506
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>

          <tr>
            <td className="xl69" height="17">
              Costa Rica-Mobile
            </td>
            <td className="xl69" align="right">
              5068
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Croatia
            </td>
            <td className="xl66" align="right">
              385
            </td>
            <td className="xl67">0.08</td>
            <td className="xl67">0.08</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Croatia-Mobile
            </td>
            <td className="xl69" align="right">
              38598
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Croatia-Mobile Vipnet
            </td>
            <td className="xl66" align="right">
              38591
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cuba
            </td>
            <td className="xl69" align="right">
              53
            </td>
            <td className="xl70">1.5</td>
            <td className="xl70">1.5</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Cuba-Guantanamo Bay
            </td>
            <td className="xl66" align="right">
              5399
            </td>
            <td className="xl67">1.15</td>
            <td className="xl67">1.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cyprus
            </td>
            <td className="xl69" align="right">
              357
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Cyprus Special Services
            </td>
            <td className="xl66" align="right">
              357700
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cyprus-Mobile
            </td>
            <td className="xl69" align="right">
              3579
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Cyprus-Mobile Vodafone
            </td>
            <td className="xl66" align="right">
              35799
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Cyprus-Mobile-Mtn
            </td>
            <td className="xl69" align="right">
              35796
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Czech Republic
            </td>
            <td className="xl66" align="right">
              420
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Czech Republic-Mobile
            </td>
            <td className="xl69" align="right">
              42060
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Czech Republic-Prague
            </td>
            <td className="xl66" align="right">
              4202
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Dem Rep Congo (Zaire)
            </td>
            <td className="xl69" align="right">
              243
            </td>
            <td className="xl70">0.32</td>
            <td className="xl70">0.32</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Dem Rep Congo (Zaire)-Mobile
            </td>
            <td className="xl66" align="right">
              24388
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Dem Rep Congo (Zaire)-Mobile Cct
            </td>
            <td className="xl69" align="right">
              24384
            </td>
            <td className="xl70">0.31</td>
            <td className="xl70">0.31</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Dem Rep Congo (Zaire)-Mobile Sait
            </td>
            <td className="xl66" align="right">
              24389
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Dem Rep Congo (Zaire)-Mobile Vodacom
            </td>
            <td className="xl69" align="right">
              24381
            </td>
            <td className="xl70">0.31</td>
            <td className="xl70">0.31</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Dem Rep Congo (Zaire)-Mobile-Zain
            </td>
            <td className="xl66" align="right">
              24397
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Denmark
            </td>
            <td className="xl69" align="right">
              45
            </td>
            <td className="xl70">0.04</td>
            <td className="xl70">0.04</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Denmark-Mobile
            </td>
            <td className="xl66" align="right">
              452
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Denmark-Special-Services
            </td>
            <td className="xl69" align="right">
              4570
            </td>
            <td className="xl70">0.04</td>
            <td className="xl70">0.04</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Diego Garcia
            </td>
            <td className="xl66" align="right">
              246
            </td>
            <td className="xl67">1.12</td>
            <td className="xl67">1.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Djibouti
            </td>
            <td className="xl69" align="right">
              253
            </td>
            <td className="xl70">0.43</td>
            <td className="xl70">0.43</td>
            <td className="xl69">peak</td>
          </tr>

          <tr>
            <td className="xl66" height="17">
              Dominica
            </td>
            <td className="xl66" align="right">
              1767
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Dominica C&amp;W Mobile
            </td>
            <td className="xl69" align="right">
              1767225
            </td>
            <td className="xl70">0.28</td>
            <td className="xl70">0.28</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Dominica Mobile
            </td>
            <td className="xl66" align="right">
              1767315
            </td>
            <td className="xl67">0.28</td>
            <td className="xl67">0.28</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Dominican Republic
            </td>
            <td className="xl69" align="right">
              1809
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Dominican Republic-Mobile
            </td>
            <td className="xl66" align="right">
              1809204
            </td>
            <td className="xl67">0.18</td>
            <td className="xl67">0.18</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              East Timor
            </td>
            <td className="xl69" align="right">
              670
            </td>
            <td className="xl70">0.99</td>
            <td className="xl70">0.99</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ecuador
            </td>
            <td className="xl66" align="right">
              593
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ecuador-Cuenca
            </td>
            <td className="xl69" align="right">
              593728
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ecuador-Guayaquil
            </td>
            <td className="xl66" align="right">
              5934
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ecuador-Mobile
            </td>
            <td className="xl69" align="right">
              5939
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ecuador-Mobile Movistar
            </td>
            <td className="xl66" align="right">
              59398
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ecuador-Mobile Porta
            </td>
            <td className="xl69" align="right">
              593993
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ecuador-Mobile-Alegro
            </td>
            <td className="xl66" align="right">
              59396
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ecuador-Quito
            </td>
            <td className="xl69" align="right">
              5932
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Egypt
            </td>
            <td className="xl66" align="right">
              20
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Egypt-Alexandria
            </td>
            <td className="xl69" align="right">
              203
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Egypt-Cairo
            </td>
            <td className="xl66" align="right">
              202
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Egypt-Mobile
            </td>
            <td className="xl69" align="right">
              2012
            </td>
            <td className="xl70">0.16</td>
            <td className="xl70">0.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              El Salvador
            </td>
            <td className="xl66" align="right">
              503
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              El Salvador Cell 5038
            </td>
            <td className="xl69" align="right">
              5038
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              El Salvador Cell Telefonica
            </td>
            <td className="xl66" align="right">
              503710
            </td>
            <td className="xl67">0.14</td>
            <td className="xl67">0.14</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              El Salvador Cell-Digicel
            </td>
            <td className="xl69" align="right">
              50373
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              El Salvador Cell-Personal
            </td>
            <td className="xl66" align="right">
              50370
            </td>
            <td className="xl67">0.14</td>
            <td className="xl67">0.14</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              El Salvador Cell-Telemovil
            </td>
            <td className="xl69" align="right">
              50372
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              El Salvador,Cte
            </td>
            <td className="xl66" align="right">
              50322010
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              El Salvador-Telefonica
            </td>
            <td className="xl69" align="right">
              5032200
            </td>
            <td className="xl70">0.12</td>
            <td className="xl70">0.12</td>
            <td className="xl69">peak</td>
          </tr>

          <tr>
            <td className="xl66" height="17">
              Emsat-Thuraya
            </td>
            <td className="xl66" align="right">
              882
            </td>
            <td className="xl67">1.7</td>
            <td className="xl67">1.7</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Equat. Guinea
            </td>
            <td className="xl69" align="right">
              240
            </td>
            <td className="xl70">0.24</td>
            <td className="xl70">0.24</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Eritrea
            </td>
            <td className="xl66" align="right">
              291
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Estonia
            </td>
            <td className="xl69" align="right">
              372
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Estonia-Mobile
            </td>
            <td className="xl66" align="right">
              3725
            </td>
            <td className="xl67">0.33</td>
            <td className="xl67">0.33</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ethiopia
            </td>
            <td className="xl69" align="right">
              251
            </td>
            <td className="xl70">0.35</td>
            <td className="xl70">0.35</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ethiopia Cellular-Addis Abeba
            </td>
            <td className="xl66" align="right">
              251911
            </td>
            <td className="xl67">0.35</td>
            <td className="xl67">0.35</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ethiopia-Addis Ababa
            </td>
            <td className="xl69" align="right">
              25111
            </td>
            <td className="xl70">0.35</td>
            <td className="xl70">0.35</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ethiopia-Mobile
            </td>
            <td className="xl66" align="right">
              2519
            </td>
            <td className="xl67">0.35</td>
            <td className="xl67">0.35</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Falkland Islands
            </td>
            <td className="xl69" align="right">
              500
            </td>
            <td className="xl70">1</td>
            <td className="xl70">1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Faroe Islands
            </td>
            <td className="xl66" align="right">
              298
            </td>
            <td className="xl67">0.19</td>
            <td className="xl67">0.19</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Fiji Islands
            </td>
            <td className="xl69" align="right">
              679
            </td>
            <td className="xl70">0.3</td>
            <td className="xl70">0.3</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Finland
            </td>
            <td className="xl66" align="right">
              358
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Finland-Mobile
            </td>
            <td className="xl69" align="right">
              3584
            </td>
            <td className="xl70">0.25</td>
            <td className="xl70">0.25</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              France
            </td>
            <td className="xl66" align="right">
              33
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              France Premium
            </td>
            <td className="xl69" align="right">
              338
            </td>
            <td className="xl70">0.02</td>
            <td className="xl70">0.02</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              France-Mobile
            </td>
            <td className="xl66" align="right">
              336
            </td>
            <td className="xl67">0.18</td>
            <td className="xl67">0.18</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              France-Mobile Bouygues
            </td>
            <td className="xl69" align="right">
              33698
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              France-Mobile Orange
            </td>
            <td className="xl66" align="right">
              3367
            </td>
            <td className="xl67">0.18</td>
            <td className="xl67">0.18</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              France-Mobile Sfr
            </td>
            <td className="xl69" align="right">
              3361
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              France-Paris
            </td>
            <td className="xl66" align="right">
              331
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              French Guiana
            </td>
            <td className="xl69" align="right">
              594
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              French Guiana-Mobile
            </td>
            <td className="xl66" align="right">
              594694
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              French Polynesia
            </td>
            <td className="xl69" align="right">
              689
            </td>
            <td className="xl70">0.3</td>
            <td className="xl70">0.3</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Gabon Republic
            </td>
            <td className="xl66" align="right">
              241
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Gabon Republic Mobile
            </td>
            <td className="xl69" align="right">
              2410
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Gabon Republic Mobile Zain
            </td>
            <td className="xl66" align="right">
              24107
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Gambia
            </td>
            <td className="xl69" align="right">
              220
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Georgia
            </td>
            <td className="xl66" align="right">
              995
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Georgia-Mobile
            </td>
            <td className="xl69" align="right">
              99577
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Georgia-Tbilisi
            </td>
            <td className="xl66" align="right">
              99532
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Germany
            </td>
            <td className="xl69" align="right">
              49
            </td>
            <td className="xl70">0.02</td>
            <td className="xl70">0.02</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Germany-Frankfurt
            </td>
            <td className="xl66" align="right">
              4969
            </td>
            <td className="xl67">0.02</td>
            <td className="xl67">0.02</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Germany-Hamburg
            </td>
            <td className="xl69" align="right">
              4940
            </td>
            <td className="xl70">0.02</td>
            <td className="xl70">0.02</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Germany-Mobile
            </td>
            <td className="xl66" align="right">
              4917
            </td>
            <td className="xl67">0.27</td>
            <td className="xl67">0.27</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Germany-Mobile Eplus
            </td>
            <td className="xl69" align="right">
              49155
            </td>
            <td className="xl70">0.27</td>
            <td className="xl70">0.27</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ghana
            </td>
            <td className="xl66" align="right">
              233
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ghana-Accra
            </td>
            <td className="xl69" align="right">
              233302
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ghana-Mobile
            </td>
            <td className="xl66" align="right">
              23320
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ghana-Mobile Millicom
            </td>
            <td className="xl69" align="right">
              23327
            </td>
            <td className="xl70">0.16</td>
            <td className="xl70">0.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ghana-Mobile-Mtn
            </td>
            <td className="xl66" align="right">
              23324
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Gibraltar
            </td>
            <td className="xl69" align="right">
              350
            </td>
            <td className="xl70">0.08</td>
            <td className="xl70">0.08</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Gibraltar-Mobile
            </td>
            <td className="xl66" align="right">
              35054
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Greece
            </td>
            <td className="xl69" align="right">
              30
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Greece-Athens
            </td>
            <td className="xl66" align="right">
              3021
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Greece-Mobile
            </td>
            <td className="xl69" align="right">
              3069
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Greece-Mobile Wind Hellas
            </td>
            <td className="xl66" align="right">
              30699
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Greenland
            </td>
            <td className="xl69" align="right">
              299
            </td>
            <td className="xl70">0.53</td>
            <td className="xl70">0.53</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Greenland-Mobile
            </td>
            <td className="xl66" align="right">
              2994
            </td>
            <td className="xl67">0.45</td>
            <td className="xl67">0.45</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Grenada
            </td>
            <td className="xl69" align="right">
              1473
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Grenada-C&amp;W Mobile
            </td>
            <td className="xl66" align="right">
              1473403
            </td>
            <td className="xl67">0.35</td>
            <td className="xl67">0.35</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Grenada-Mobile
            </td>
            <td className="xl69" align="right">
              1473414
            </td>
            <td className="xl70">0.35</td>
            <td className="xl70">0.35</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Guadeloupe
            </td>
            <td className="xl66" align="right">
              590
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Guadeloupe-Mobile
            </td>
            <td className="xl69" align="right">
              590690
            </td>
            <td className="xl70">0.39</td>
            <td className="xl70">0.39</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Guam
            </td>
            <td className="xl66" align="right">
              1671
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Guatemala
            </td>
            <td className="xl69" align="right">
              502
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Guatemala - Telgua
            </td>
            <td className="xl66" align="right">
              5022220
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Guatemala-Cellular Pcs Sercom
            </td>
            <td className="xl69" align="right">
              5022223
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Guatemala-Cellular Telefonica
            </td>
            <td className="xl66" align="right">
              5022229
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Guatemala-Mobile
            </td>
            <td className="xl69" align="right">
              5025
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Guatemala-Mobile-Comcel
            </td>
            <td className="xl66" align="right">
              502532
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Guinea
            </td>
            <td className="xl69" align="right">
              224
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Guinea-Bissau
            </td>
            <td className="xl66" align="right">
              245
            </td>
            <td className="xl67">0.64</td>
            <td className="xl67">0.64</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Guinea-Mobile
            </td>
            <td className="xl69" align="right">
              22465
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Guinea-Mobile Orange
            </td>
            <td className="xl66" align="right">
              22462
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Guinea-Mobile Sotelgui
            </td>
            <td className="xl69" align="right">
              22460
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Guinea-Mobile-Mtn
            </td>
            <td className="xl66" align="right">
              22464
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Guyana
            </td>
            <td className="xl69" align="right">
              592
            </td>
            <td className="xl70">0.36</td>
            <td className="xl70">0.36</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Guyana Mobile-Digicel
            </td>
            <td className="xl66" align="right">
              59266
            </td>
            <td className="xl67">0.38</td>
            <td className="xl67">0.38</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Guyana-Mobile
            </td>
            <td className="xl69" align="right">
              5926
            </td>
            <td className="xl70">0.38</td>
            <td className="xl70">0.38</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Haiti
            </td>
            <td className="xl66" align="right">
              509
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Haiti-Mobile
            </td>
            <td className="xl69" align="right">
              5095
            </td>
            <td className="xl70">0.32</td>
            <td className="xl70">0.32</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Haiti-Mobile-Comcel
            </td>
            <td className="xl66" align="right">
              50939
            </td>
            <td className="xl67">0.32</td>
            <td className="xl67">0.32</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Haiti-Mobile-Digicel
            </td>
            <td className="xl69" align="right">
              5097
            </td>
            <td className="xl70">0.32</td>
            <td className="xl70">0.32</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Haiti-Port Au Prince
            </td>
            <td className="xl66" align="right">
              50921
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Honduras
            </td>
            <td className="xl69" align="right">
              504
            </td>
            <td className="xl70">0.37</td>
            <td className="xl70">0.37</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Honduras Mobile-Ctel
            </td>
            <td className="xl66" align="right">
              50495
            </td>
            <td className="xl67">0.38</td>
            <td className="xl67">0.38</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Honduras-Mobile
            </td>
            <td className="xl69" align="right">
              5049
            </td>
            <td className="xl70">0.38</td>
            <td className="xl70">0.38</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Honduras-Mobile Claro
            </td>
            <td className="xl66" align="right">
              504316
            </td>
            <td className="xl67">0.38</td>
            <td className="xl67">0.38</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Hong Kong
            </td>
            <td className="xl69" align="right">
              852
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Hong Kong-Mobile
            </td>
            <td className="xl66" align="right">
              8526
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Hungary
            </td>
            <td className="xl69" align="right">
              36
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Hungary-Budapest
            </td>
            <td className="xl66" align="right">
              361
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Hungary-Mobile
            </td>
            <td className="xl69" align="right">
              3620
            </td>
            <td className="xl70">0.25</td>
            <td className="xl70">0.25</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Iceland
            </td>
            <td className="xl66" align="right">
              354
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Iceland-Mobile
            </td>
            <td className="xl69" align="right">
              3546
            </td>
            <td className="xl70">0.25</td>
            <td className="xl70">0.25</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Inbound Esp To On-Net
            </td>
            <td className="xl66">*1003</td>
            <td className="xl67">0</td>
            <td className="xl67">0</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Inbound Off-Net To On-Net
            </td>
            <td className="xl69">*1001</td>
            <td className="xl70">0</td>
            <td className="xl70">0</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Inbound Off-Net To On-Net Toll Free
            </td>
            <td className="xl66">*1007</td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Inbound On-Net To On-Net
            </td>
            <td className="xl69">*1000</td>
            <td className="xl70">0</td>
            <td className="xl70">0</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Inbound On-Net To On-Net Toll Free
            </td>
            <td className="xl66">*1006</td>
            <td className="xl67">0</td>
            <td className="xl67">0</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Inbound On-Net To Voicemail
            </td>
            <td className="xl69">*1004</td>
            <td className="xl70">0</td>
            <td className="xl70">0</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              India
            </td>
            <td className="xl66" align="right">
              91
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              India-Ahmadabad
            </td>
            <td className="xl69" align="right">
              9179
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              India-Bangalore
            </td>
            <td className="xl66" align="right">
              9180
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              India-Baroda (Vadodara)
            </td>
            <td className="xl69" align="right">
              91265
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              India-Bombay (Mumbai)
            </td>
            <td className="xl66" align="right">
              9122
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              India-Calcutta
            </td>
            <td className="xl69" align="right">
              9133
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              India-Gujarat
            </td>
            <td className="xl66" align="right">
              9126
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              India-Hyderabad
            </td>
            <td className="xl69" align="right">
              9140
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              India-Kerala
            </td>
            <td className="xl66" align="right">
              9147
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              India-Madras (Chennai)
            </td>
            <td className="xl69" align="right">
              9144
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              India-Mobile
            </td>
            <td className="xl66" align="right">
              9198
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              India-Mobile-Bsnl
            </td>
            <td className="xl69" align="right">
              9194
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              India-New Delhi
            </td>
            <td className="xl66" align="right">
              9111
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Indonesia
            </td>
            <td className="xl69" align="right">
              62
            </td>
            <td className="xl70">0.11</td>
            <td className="xl70">0.11</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Indonesia Mobile Exelcom
            </td>
            <td className="xl66" align="right">
              62817
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Indonesia-Jakarta
            </td>
            <td className="xl69" align="right">
              6221
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Indonesia-Mobile
            </td>
            <td className="xl66" align="right">
              628
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Indonesia-Mobile Hutchison
            </td>
            <td className="xl69" align="right">
              62896
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Indonesia-Mobile Indosat
            </td>
            <td className="xl66" align="right">
              62815
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Indonesia-Mobile Telekomsel
            </td>
            <td className="xl69" align="right">
              62811
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Indonesia-Surabaya
            </td>
            <td className="xl66" align="right">
              6231
            </td>
            <td className="xl67">0.11</td>
            <td className="xl67">0.11</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Inmarsat
            </td>
            <td className="xl69" align="right">
              870
            </td>
            <td className="xl70">2.4</td>
            <td className="xl70">2.4</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Inmarsat-Indian Ocean
            </td>
            <td className="xl66" align="right">
              873
            </td>
            <td className="xl67">2.35</td>
            <td className="xl67">2.35</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Iran
            </td>
            <td className="xl69" align="right">
              98
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Iran-Mobile
            </td>
            <td className="xl66" align="right">
              989
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Iran-Tehran
            </td>
            <td className="xl69" align="right">
              9821
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Iraq
            </td>
            <td className="xl66" align="right">
              964
            </td>
            <td className="xl67">0.44</td>
            <td className="xl67">0.44</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Iraq-Baghdad
            </td>
            <td className="xl69" align="right">
              9641
            </td>
            <td className="xl70">0.44</td>
            <td className="xl70">0.44</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Iraq-Mobile
            </td>
            <td className="xl66" align="right">
              9647
            </td>
            <td className="xl67">0.44</td>
            <td className="xl67">0.44</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ireland
            </td>
            <td className="xl69" align="right">
              353
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ireland Cellular-Vodafone
            </td>
            <td className="xl66" align="right">
              35387
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ireland-Mobile
            </td>
            <td className="xl69" align="right">
              35385
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Iridium-Globalstar
            </td>
            <td className="xl66" align="right">
              881
            </td>
            <td className="xl67">2</td>
            <td className="xl67">2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Israel
            </td>
            <td className="xl69" align="right">
              972
            </td>
            <td className="xl70">0.04</td>
            <td className="xl70">0.04</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Israel-Jerusalem
            </td>
            <td className="xl66" align="right">
              9722
            </td>
            <td className="xl67">0.04</td>
            <td className="xl67">0.04</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Israel-Mobile
            </td>
            <td className="xl69" align="right">
              9725
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Israel-Pa
            </td>
            <td className="xl66" align="right">
              97222
            </td>
            <td className="xl67">0.19</td>
            <td className="xl67">0.19</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Israel-Pa Mobile
            </td>
            <td className="xl69" align="right">
              97259
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Israel-Tel Aviv
            </td>
            <td className="xl66" align="right">
              9723
            </td>
            <td className="xl67">0.04</td>
            <td className="xl67">0.04</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Italy
            </td>
            <td className="xl69" align="right">
              39
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Italy-Milan
            </td>
            <td className="xl66" align="right">
              3902
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Italy-Mobile
            </td>
            <td className="xl69" align="right">
              393
            </td>
            <td className="xl70">0.29</td>
            <td className="xl70">0.29</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Italy-Mobile Tim
            </td>
            <td className="xl66" align="right">
              3933
            </td>
            <td className="xl67">0.29</td>
            <td className="xl67">0.29</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Italy-Mobile Vodafone
            </td>
            <td className="xl69" align="right">
              3934
            </td>
            <td className="xl70">0.29</td>
            <td className="xl70">0.29</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Italy-Mobile Wind
            </td>
            <td className="xl66" align="right">
              3932
            </td>
            <td className="xl67">0.29</td>
            <td className="xl67">0.29</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ivory Coast
            </td>
            <td className="xl69" align="right">
              225
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ivory Coast-Abidjan
            </td>
            <td className="xl66" align="right">
              2252
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ivory Coast-Cellular Comium
            </td>
            <td className="xl69" align="right">
              22566
            </td>
            <td className="xl70">0.3</td>
            <td className="xl70">0.3</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ivory Coast-Cellular Orange
            </td>
            <td className="xl66" align="right">
              22507
            </td>
            <td className="xl67">0.3</td>
            <td className="xl67">0.3</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ivory Coast-Cellular-Mtn
            </td>
            <td className="xl69" align="right">
              22504
            </td>
            <td className="xl70">0.3</td>
            <td className="xl70">0.3</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ivory Coast-Mobile
            </td>
            <td className="xl66" align="right">
              2250
            </td>
            <td className="xl67">0.3</td>
            <td className="xl67">0.3</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Jamaica
            </td>
            <td className="xl69" align="right">
              1876
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Jamaica-C&amp;W Cellular
            </td>
            <td className="xl66" align="right">
              1876210
            </td>
            <td className="xl67">0.29</td>
            <td className="xl67">0.29</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Jamaica-Cellular-Digicell
            </td>
            <td className="xl69" align="right">
              187635
            </td>
            <td className="xl70">0.29</td>
            <td className="xl70">0.29</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Jamaica-Gotel
            </td>
            <td className="xl66" align="right">
              1876697
            </td>
            <td className="xl67">0.14</td>
            <td className="xl67">0.14</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Jamaica-Mobile
            </td>
            <td className="xl69" align="right">
              1876301
            </td>
            <td className="xl70">0.29</td>
            <td className="xl70">0.29</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Japan
            </td>
            <td className="xl66" align="right">
              81
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Japan-Mobile
            </td>
            <td className="xl69" align="right">
              8170
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Japan-Osaka
            </td>
            <td className="xl66" align="right">
              816
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Japan-Tokyo
            </td>
            <td className="xl69" align="right">
              813
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Jordan
            </td>
            <td className="xl66" align="right">
              962
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Jordan-Amman
            </td>
            <td className="xl69" align="right">
              9626
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Jordan-Mobile
            </td>
            <td className="xl66" align="right">
              9627
            </td>
            <td className="xl67">0.24</td>
            <td className="xl67">0.24</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Jordan-Mobile Zain
            </td>
            <td className="xl69" align="right">
              96279
            </td>
            <td className="xl70">0.24</td>
            <td className="xl70">0.24</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Kazakhstan
            </td>
            <td className="xl66" align="right">
              731
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Kazakhstan-Almaty
            </td>
            <td className="xl69" align="right">
              77272
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Kazakhstan-Almaty
            </td>
            <td className="xl66" align="right">
              77273
            </td>
            <td className="xl67">0.14</td>
            <td className="xl67">0.14</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Kazakhstan-Almaty
            </td>
            <td className="xl69" align="right">
              73272
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Kazakhstan-Astana
            </td>
            <td className="xl66" align="right">
              73172
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Kazakhstan-Atyrau
            </td>
            <td className="xl69" align="right">
              73122
            </td>
            <td className="xl70">0.16</td>
            <td className="xl70">0.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Kazakhstan-Karaganda
            </td>
            <td className="xl66" align="right">
              73212
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Kazakhstan-Mobile
            </td>
            <td className="xl69" align="right">
              7300
            </td>
            <td className="xl70">0.16</td>
            <td className="xl70">0.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Kazakhstan-Pavlodar
            </td>
            <td className="xl66" align="right">
              73182
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Kenya
            </td>
            <td className="xl69" align="right">
              254
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>

          <tr>
            <td className="xl66" height="17">
              Kenya Mobile-Celtel
            </td>
            <td className="xl66" align="right">
              25473
            </td>
            <td className="xl67">0.33</td>
            <td className="xl67">0.33</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Kenya-Mobile
            </td>
            <td className="xl69" align="right">
              2547
            </td>
            <td className="xl70">0.33</td>
            <td className="xl70">0.33</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Kenya-Mobile Orange
            </td>
            <td className="xl66" align="right">
              254770
            </td>
            <td className="xl67">0.33</td>
            <td className="xl67">0.33</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Kenya-Mobile Safaricom
            </td>
            <td className="xl69" align="right">
              25471
            </td>
            <td className="xl70">0.33</td>
            <td className="xl70">0.33</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Kenya-Nairobi
            </td>
            <td className="xl66" align="right">
              25420
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Kiribati
            </td>
            <td className="xl69" align="right">
              686
            </td>
            <td className="xl70">0.9</td>
            <td className="xl70">0.9</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Kuwait
            </td>
            <td className="xl66" align="right">
              965
            </td>
            <td className="xl67">0.11</td>
            <td className="xl67">0.11</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Kuwait-Mobile
            </td>
            <td className="xl69" align="right">
              9656
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Kuwait-Mobile Vodafone
            </td>
            <td className="xl66" align="right">
              9659
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Kyrgyzstan
            </td>
            <td className="xl69" align="right">
              996
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Kyrgyzstan-Mobile
            </td>
            <td className="xl66" align="right">
              9965
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Laos
            </td>
            <td className="xl69" align="right">
              856
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Latvia
            </td>
            <td className="xl66" align="right">
              371
            </td>
            <td className="xl67">0.14</td>
            <td className="xl67">0.14</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Latvia Premium
            </td>
            <td className="xl69" align="right">
              3716515
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Latvia-Mobile
            </td>
            <td className="xl66" align="right">
              3712
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Latvia-Riga
            </td>
            <td className="xl69" align="right">
              3717
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Lebanon
            </td>
            <td className="xl66" align="right">
              961
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Lebanon-Mobile
            </td>
            <td className="xl69" align="right">
              9613
            </td>
            <td className="xl70">0.26</td>
            <td className="xl70">0.26</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Lesotho
            </td>
            <td className="xl66" align="right">
              266
            </td>
            <td className="xl67">0.29</td>
            <td className="xl67">0.29</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Liberia
            </td>
            <td className="xl69" align="right">
              231
            </td>
            <td className="xl70">0.35</td>
            <td className="xl70">0.35</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Liberia Cellular-Cellcom
            </td>
            <td className="xl66" align="right">
              2317
            </td>
            <td className="xl67">0.35</td>
            <td className="xl67">0.35</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Liberia Cellular-Comium
            </td>
            <td className="xl69" align="right">
              2315
            </td>
            <td className="xl70">0.35</td>
            <td className="xl70">0.35</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Liberia Cellular-Libercell
            </td>
            <td className="xl66" align="right">
              2314
            </td>
            <td className="xl67">0.35</td>
            <td className="xl67">0.35</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Liberia Cellular-Libtelco
            </td>
            <td className="xl69" align="right">
              23212
            </td>
            <td className="xl70">0.35</td>
            <td className="xl70">0.35</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Liberia Cellular-Mtn
            </td>
            <td className="xl66" align="right">
              2316
            </td>
            <td className="xl67">0.35</td>
            <td className="xl67">0.35</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Libya
            </td>
            <td className="xl69" align="right">
              218
            </td>
            <td className="xl70">0.27</td>
            <td className="xl70">0.27</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Libya-Mobile
            </td>
            <td className="xl66" align="right">
              2189
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Liechtenstein
            </td>
            <td className="xl69" align="right">
              423
            </td>
            <td className="xl70">0.07</td>
            <td className="xl70">0.07</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Liechtenstein-Mobile
            </td>
            <td className="xl66" align="right">
              4236
            </td>
            <td className="xl67">0.72</td>
            <td className="xl67">0.72</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Lithuania
            </td>
            <td className="xl69" align="right">
              370
            </td>
            <td className="xl70">0.11</td>
            <td className="xl70">0.11</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Lithuania Premium
            </td>
            <td className="xl66" align="right">
              3709
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Lithuania-Mobile
            </td>
            <td className="xl69" align="right">
              3706
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Luxembourg
            </td>
            <td className="xl66" align="right">
              352
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Luxembourg Mobile
            </td>
            <td className="xl69" align="right">
              3526201
            </td>
            <td className="xl70">0.29</td>
            <td className="xl70">0.29</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Macao
            </td>
            <td className="xl66" align="right">
              853
            </td>
            <td className="xl67">0.08</td>
            <td className="xl67">0.08</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Macedonia
            </td>
            <td className="xl69" align="right">
              389
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Macedonia-Mobile
            </td>
            <td className="xl66" align="right">
              3897
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Macedonia-Skopje
            </td>
            <td className="xl69" align="right">
              3892
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Madagascar
            </td>
            <td className="xl66" align="right">
              261
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Madagascar Mobile
            </td>
            <td className="xl69" align="right">
              2613
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Madagascar Mobile Orange
            </td>
            <td className="xl66" align="right">
              26132
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Madagascar Mobile Telma
            </td>
            <td className="xl69" align="right">
              26134
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Madagascar Mobile Zain
            </td>
            <td className="xl66" align="right">
              26133
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Malawi
            </td>
            <td className="xl69" align="right">
              265
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Malawi-Mobile
            </td>
            <td className="xl66" align="right">
              2654
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Malawi-Mobile Celtel
            </td>
            <td className="xl69" align="right">
              2655
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Malaysia
            </td>
            <td className="xl66" align="right">
              60
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Malaysia-Kuala Lumpur
            </td>
            <td className="xl69" align="right">
              603
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Malaysia-Mobile
            </td>
            <td className="xl66" align="right">
              601
            </td>
            <td className="xl67">0.07</td>
            <td className="xl67">0.07</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Maldives
            </td>
            <td className="xl69" align="right">
              960
            </td>
            <td className="xl70">0.28</td>
            <td className="xl70">0.28</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Maldives-Mobile
            </td>
            <td className="xl66" align="right">
              9607
            </td>
            <td className="xl67">0.28</td>
            <td className="xl67">0.28</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mali
            </td>
            <td className="xl69" align="right">
              223
            </td>
            <td className="xl70">0.26</td>
            <td className="xl70">0.26</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mali-Bamako
            </td>
            <td className="xl66" align="right">
              223202
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mali-Mobile Malitel
            </td>
            <td className="xl69" align="right">
              223630
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mali-Mobile Orange
            </td>
            <td className="xl66" align="right">
              22370
            </td>
            <td className="xl67">0.33</td>
            <td className="xl67">0.33</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Malta
            </td>
            <td className="xl69" align="right">
              356
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Malta-Mobile
            </td>
            <td className="xl66" align="right">
              3569
            </td>
            <td className="xl67">0.52</td>
            <td className="xl67">0.52</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Marshall Islands
            </td>
            <td className="xl69" align="right">
              692
            </td>
            <td className="xl70">0.39</td>
            <td className="xl70">0.39</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Martinique
            </td>
            <td className="xl66" align="right">
              596
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Martinique-Mobile
            </td>
            <td className="xl69" align="right">
              596696
            </td>
            <td className="xl70">0.37</td>
            <td className="xl70">0.37</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mauritania
            </td>
            <td className="xl66" align="right">
              222
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mauritius
            </td>
            <td className="xl69" align="right">
              230
            </td>
            <td className="xl70">0.22</td>
            <td className="xl70">0.22</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mauritius Mobile
            </td>
            <td className="xl66" align="right">
              23025
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mauritius Rodriguez
            </td>
            <td className="xl69" align="right">
              2308
            </td>
            <td className="xl70">0.22</td>
            <td className="xl70">0.22</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mayotte
            </td>
            <td className="xl66" align="right">
              26976
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mexico
            </td>
            <td className="xl69" align="right">
              52
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mexico Ea 1
            </td>
            <td className="xl66" align="right">
              52834
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mexico Ea 2
            </td>
            <td className="xl69" align="right">
              52475
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mexico Ea 3
            </td>
            <td className="xl66" align="right">
              52626
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mexico-Guadalajara-Mobile
            </td>
            <td className="xl69" align="right">
              52133
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mexico-Gudalajara
            </td>
            <td className="xl66" align="right">
              52333
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>

          <tr>
            <td className="xl69" height="17">
              Mexico-Gudalajara 5233
            </td>
            <td className="xl69" align="right">
              5233
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mexico-Mexico City
            </td>
            <td className="xl66" align="right">
              52555
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mexico-Mexico City 5255
            </td>
            <td className="xl69" align="right">
              5255
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mexico-Mexico City-Mobile
            </td>
            <td className="xl66" align="right">
              52155
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mexico-Mobile
            </td>
            <td className="xl69" align="right">
              521
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mexico-Monterrey
            </td>
            <td className="xl66" align="right">
              52818
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mexico-Monterrey 5281
            </td>
            <td className="xl69" align="right">
              5281
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mexico-Monterrey-Mobile
            </td>
            <td className="xl66" align="right">
              52181
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mexico-Puebla
            </td>
            <td className="xl69" align="right">
              52222
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Micronesia
            </td>
            <td className="xl66" align="right">
              691
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Moldova
            </td>
            <td className="xl69" align="right">
              373
            </td>
            <td className="xl70">0.16</td>
            <td className="xl70">0.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Moldova-Chisinau
            </td>
            <td className="xl66" align="right">
              3732
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Moldova-Mobile
            </td>
            <td className="xl69" align="right">
              37369
            </td>
            <td className="xl70">0.24</td>
            <td className="xl70">0.24</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Moldova-Pridnestrovie
            </td>
            <td className="xl66" align="right">
              3735
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Monaco
            </td>
            <td className="xl69" align="right">
              377
            </td>
            <td className="xl70">0.08</td>
            <td className="xl70">0.08</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Monaco-Mobile
            </td>
            <td className="xl66" align="right">
              3776
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Monaco-Mobile Kfor
            </td>
            <td className="xl69" align="right">
              3774
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mongolia
            </td>
            <td className="xl66" align="right">
              976
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Montenegro
            </td>
            <td className="xl69" align="right">
              382
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Montenegro Cellular
            </td>
            <td className="xl66" align="right">
              38267
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Montserrat
            </td>
            <td className="xl69" align="right">
              1664
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Montserrat-Mobile
            </td>
            <td className="xl66" align="right">
              166410
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Morocco
            </td>
            <td className="xl69" align="right">
              212
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Morocco Cellular Maroc
            </td>
            <td className="xl66" align="right">
              212610
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Morocco Cellular Meditel
            </td>
            <td className="xl69" align="right">
              212612
            </td>
            <td className="xl70">0.31</td>
            <td className="xl70">0.31</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Morocco-Casablanca
            </td>
            <td className="xl66" align="right">
              212522
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Morocco-Marco
            </td>
            <td className="xl69" align="right">
              212539
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Morocco-Mobile
            </td>
            <td className="xl66" align="right">
              2126
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Morocco-Rabat
            </td>
            <td className="xl69" align="right">
              212537
            </td>
            <td className="xl70">0.22</td>
            <td className="xl70">0.22</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mozambique
            </td>
            <td className="xl66" align="right">
              258
            </td>
            <td className="xl67">0.18</td>
            <td className="xl67">0.18</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mozambique-Mobile
            </td>
            <td className="xl69" align="right">
              2588
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Mozambique-Mobile Vodacom
            </td>
            <td className="xl66" align="right">
              25884
            </td>
            <td className="xl67">0.18</td>
            <td className="xl67">0.18</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Mozambique-Mobile-Mcel
            </td>
            <td className="xl69" align="right">
              25882
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Namibia
            </td>
            <td className="xl66" align="right">
              264
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Namibia-Mobile
            </td>
            <td className="xl69" align="right">
              26481
            </td>
            <td className="xl70">0.25</td>
            <td className="xl70">0.25</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Nauru
            </td>
            <td className="xl66" align="right">
              674
            </td>
            <td className="xl67">0.99</td>
            <td className="xl67">0.99</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Nepal
            </td>
            <td className="xl69" align="right">
              977
            </td>
            <td className="xl70">0.31</td>
            <td className="xl70">0.31</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Nepal-Kathmandu
            </td>
            <td className="xl66" align="right">
              9771
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Nepal-Mobile
            </td>
            <td className="xl69" align="right">
              97798
            </td>
            <td className="xl70">0.31</td>
            <td className="xl70">0.31</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Nepal-Mobile Spice
            </td>
            <td className="xl66" align="right">
              977980
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Netherlands
            </td>
            <td className="xl69" align="right">
              31
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Netherlands Antilles
            </td>
            <td className="xl66" align="right">
              599
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Netherlands Antilles-Mobile
            </td>
            <td className="xl69" align="right">
              59951
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Netherlands Special Services
            </td>
            <td className="xl66" align="right">
              319
            </td>
            <td className="xl67">0.31</td>
            <td className="xl67">0.31</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Netherlands,Rotterdam
            </td>
            <td className="xl69" align="right">
              3110
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Netherlands-Amsterdam
            </td>
            <td className="xl66" align="right">
              3120
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Netherlands-Mobile
            </td>
            <td className="xl69" align="right">
              316
            </td>
            <td className="xl70">0.31</td>
            <td className="xl70">0.31</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              New Caledonia
            </td>
            <td className="xl66" align="right">
              687
            </td>
            <td className="xl67">0.41</td>
            <td className="xl67">0.41</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              New Zealand
            </td>
            <td className="xl69" align="right">
              64
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              New Zealand-Mobile
            </td>
            <td className="xl66" align="right">
              642
            </td>
            <td className="xl67">0.29</td>
            <td className="xl67">0.29</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Nicaragua
            </td>
            <td className="xl69" align="right">
              505
            </td>
            <td className="xl70">0.19</td>
            <td className="xl70">0.19</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Nicaragua Mobile Claro
            </td>
            <td className="xl66" align="right">
              50533
            </td>
            <td className="xl67">0.29</td>
            <td className="xl67">0.29</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Nicaragua-Mobile
            </td>
            <td className="xl69" align="right">
              5058
            </td>
            <td className="xl70">0.29</td>
            <td className="xl70">0.29</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Niger
            </td>
            <td className="xl66" align="right">
              227
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Niger Cellular-Moov
            </td>
            <td className="xl69" align="right">
              22794
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Niger Cellular-Sahelcom
            </td>
            <td className="xl66" align="right">
              22793
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Niger Cellular-Zain
            </td>
            <td className="xl69" align="right">
              22796
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Niger Mobile
            </td>
            <td className="xl66" align="right">
              2279
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Niger Mobile-Orange
            </td>
            <td className="xl69" align="right">
              22790
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Nigeria
            </td>
            <td className="xl66" align="right">
              234
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Nigeria-Abuja
            </td>
            <td className="xl69" align="right">
              2349
            </td>
            <td className="xl70">0.12</td>
            <td className="xl70">0.12</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Nigeria-Benin
            </td>
            <td className="xl66" align="right">
              23452
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Nigeria-Lagos
            </td>
            <td className="xl69" align="right">
              2341
            </td>
            <td className="xl70">0.07</td>
            <td className="xl70">0.07</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Nigeria-Lagos Ld
            </td>
            <td className="xl66" align="right">
              234177
            </td>
            <td className="xl67">0.07</td>
            <td className="xl67">0.07</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Nigeria-Mobile
            </td>
            <td className="xl69" align="right">
              23490
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Nigeria-Mobile-Globacom
            </td>
            <td className="xl66" align="right">
              234805
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Nigeria-Mobile-Mtn
            </td>
            <td className="xl69" align="right">
              234803
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Nigeria-Mobile-Vee
            </td>
            <td className="xl66" align="right">
              234802
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Nigeria-Moble Nitel
            </td>
            <td className="xl69" align="right">
              234804
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Nigeria-Onitsha
            </td>
            <td className="xl66" align="right">
              23446
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Nigeria-Port Hardcort
            </td>
            <td className="xl69" align="right">
              23484
            </td>
            <td className="xl70">0.12</td>
            <td className="xl70">0.12</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Niue
            </td>
            <td className="xl66" align="right">
              683
            </td>
            <td className="xl67">1.25</td>
            <td className="xl67">1.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Norfolk Islands
            </td>
            <td className="xl69" align="right">
              6723
            </td>
            <td className="xl70">0.75</td>
            <td className="xl70">0.75</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              North Korea
            </td>
            <td className="xl66" align="right">
              850
            </td>
            <td className="xl67">0.54</td>
            <td className="xl67">0.54</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Northern Mariana Islands
            </td>
            <td className="xl69" align="right">
              1670
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Norway
            </td>
            <td className="xl66" align="right">
              47
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Norway Special Services
            </td>
            <td className="xl69" align="right">
              4702
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Norway-Mobile
            </td>
            <td className="xl66" align="right">
              474
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Oman
            </td>
            <td className="xl69" align="right">
              968
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Oman-Mobile
            </td>
            <td className="xl66" align="right">
              9689
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Outbound On-Net Local Emergency Assistance 911
            </td>
            <td className="xl69">*2008</td>
            <td className="xl70">0</td>
            <td className="xl70">0</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Outbound On-Net To Customer Service 611
            </td>
            <td className="xl66">*2004</td>
            <td className="xl67">0</td>
            <td className="xl67">0</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Outbound On-Net To Directory Assistance 411
            </td>
            <td className="xl69">*2007</td>
            <td className="xl70">0.33</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Outbound On-Net To Local Operator 0
            </td>
            <td className="xl66">*2011</td>
            <td className="xl67">0.33</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Outbound On-Net To Local Operator W/Dialed No 0+
            </td>
            <td className="xl69">*2010</td>
            <td className="xl70">0.33</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Outbound On-Net To On-Net
            </td>
            <td className="xl66">*2000</td>
            <td className="xl67">0</td>
            <td className="xl67">0</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Outbound On-Net To Op W/ Cust Dial No (0+)
            </td>
            <td className="xl69">*2012</td>
            <td className="xl70">0</td>
            <td className="xl70">0</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Pacific Ocean
            </td>
            <td className="xl66" align="right">
              872
            </td>
            <td className="xl67">2.5</td>
            <td className="xl67">2.5</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Pakistan
            </td>
            <td className="xl69" align="right">
              92
            </td>
            <td className="xl70">0.24</td>
            <td className="xl70">0.24</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Pakistan,Cellular-Mobilink
            </td>
            <td className="xl66" align="right">
              9230
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Pakistan-Islamabad
            </td>
            <td className="xl69" align="right">
              9251
            </td>
            <td className="xl70">0.24</td>
            <td className="xl70">0.24</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Pakistan-Karachi
            </td>
            <td className="xl66" align="right">
              9221
            </td>
            <td className="xl67">0.24</td>
            <td className="xl67">0.24</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Pakistan-Lahore
            </td>
            <td className="xl69" align="right">
              9242
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Pakistan-Mobile
            </td>
            <td className="xl66" align="right">
              923
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Palau
            </td>
            <td className="xl69" align="right">
              680
            </td>
            <td className="xl70">0.49</td>
            <td className="xl70">0.49</td>
            <td className="xl69">peak</td>
          </tr>

          <tr>
            <td className="xl66" height="17">
              Palestinian Authority
            </td>
            <td className="xl66" align="right">
              970
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Palestinian Authority-Mobile
            </td>
            <td className="xl69" align="right">
              97059
            </td>
            <td className="xl70">0.159</td>
            <td className="xl70">0.159</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Panama
            </td>
            <td className="xl66" align="right">
              507
            </td>
            <td className="xl67">0.11</td>
            <td className="xl67">0.11</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Panama-Aguadulce
            </td>
            <td className="xl69" align="right">
              507986
            </td>
            <td className="xl70">0.11</td>
            <td className="xl70">0.11</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Panama-Changuinola
            </td>
            <td className="xl66" align="right">
              5077581
            </td>
            <td className="xl67">0.11</td>
            <td className="xl67">0.11</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Panama-Chitre
            </td>
            <td className="xl69" align="right">
              5079772
            </td>
            <td className="xl70">0.11</td>
            <td className="xl70">0.11</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Panama-Colon
            </td>
            <td className="xl66" align="right">
              5074
            </td>
            <td className="xl67">0.11</td>
            <td className="xl67">0.11</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Panama-David City
            </td>
            <td className="xl69" align="right">
              507721
            </td>
            <td className="xl70">0.11</td>
            <td className="xl70">0.11</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Panama-Las Tablas
            </td>
            <td className="xl66" align="right">
              5079944
            </td>
            <td className="xl67">0.11</td>
            <td className="xl67">0.11</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Panama-Mobile
            </td>
            <td className="xl69" align="right">
              5076
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Panama-Mobile C&amp;W
            </td>
            <td className="xl66" align="right">
              507650
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Panama-Panama City
            </td>
            <td className="xl69" align="right">
              5072
            </td>
            <td className="xl70">0.11</td>
            <td className="xl70">0.11</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Panama-Panama City 5075
            </td>
            <td className="xl66" align="right">
              5075
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Panama-Santiago
            </td>
            <td className="xl69" align="right">
              5079390
            </td>
            <td className="xl70">0.11</td>
            <td className="xl70">0.11</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Papau New Guinea
            </td>
            <td className="xl66" align="right">
              675
            </td>
            <td className="xl67">0.99</td>
            <td className="xl67">0.99</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Paraguay
            </td>
            <td className="xl69" align="right">
              595
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Paraguay-Asuncion
            </td>
            <td className="xl66" align="right">
              59521
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Paraguay-Mobile
            </td>
            <td className="xl69" align="right">
              595220
            </td>
            <td className="xl70">0.25</td>
            <td className="xl70">0.25</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Paraguay-Mobile-Tigo
            </td>
            <td className="xl66" align="right">
              59598
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Pccall
            </td>
            <td className="xl69">*72</td>
            <td className="xl70">0</td>
            <td className="xl70">0</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Peru
            </td>
            <td className="xl66" align="right">
              51
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Peru Mobile-Claro
            </td>
            <td className="xl69" align="right">
              519730
            </td>
            <td className="xl70">0.32</td>
            <td className="xl70">0.32</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Peru Mobile-Telefonica
            </td>
            <td className="xl66" align="right">
              511951
            </td>
            <td className="xl67">0.32</td>
            <td className="xl67">0.32</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Peru,Lima 5116
            </td>
            <td className="xl69" align="right">
              5116
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Peru-Arequipa
            </td>
            <td className="xl66" align="right">
              5154
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Peru-Lima
            </td>
            <td className="xl69" align="right">
              511
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Peru-Mobile
            </td>
            <td className="xl66" align="right">
              51419
            </td>
            <td className="xl67">0.32</td>
            <td className="xl67">0.32</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Peru-Rural
            </td>
            <td className="xl69" align="right">
              515281
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Peru-Rural 2
            </td>
            <td className="xl66" align="right">
              514181
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Peru-Trujillo
            </td>
            <td className="xl69" align="right">
              5144
            </td>
            <td className="xl70">0.09</td>
            <td className="xl70">0.09</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Philippines
            </td>
            <td className="xl66" align="right">
              63
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Philippines-Manila
            </td>
            <td className="xl69" align="right">
              632
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Philippines-Mobile
            </td>
            <td className="xl66" align="right">
              639
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Philippines-Mobile Globe
            </td>
            <td className="xl69" align="right">
              63905
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Poland
            </td>
            <td className="xl66" align="right">
              48
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Poland-Mobile
            </td>
            <td className="xl69" align="right">
              4850
            </td>
            <td className="xl70">0.24</td>
            <td className="xl70">0.24</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Poland-Warsaw
            </td>
            <td className="xl66" align="right">
              4822
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Portugal
            </td>
            <td className="xl69" align="right">
              351
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Portugal-Lisbon
            </td>
            <td className="xl66" align="right">
              35121
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Portugal-Mobile
            </td>
            <td className="xl69" align="right">
              3519
            </td>
            <td className="xl70">0.3</td>
            <td className="xl70">0.3</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Puerto Rico
            </td>
            <td className="xl66" align="right">
              1787
            </td>
            <td className="xl67">0</td>
            <td className="xl67">0</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Qatar
            </td>
            <td className="xl69" align="right">
              974
            </td>
            <td className="xl70">0.33</td>
            <td className="xl70">0.33</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Qatar-Cellular
            </td>
            <td className="xl66" align="right">
              9742
            </td>
            <td className="xl67">0.36</td>
            <td className="xl67">0.36</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Reunion Island
            </td>
            <td className="xl69" align="right">
              262
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Reunion Island,Mayotte
            </td>
            <td className="xl66" align="right">
              262269
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Reunion Island,Mayotte-Mobile
            </td>
            <td className="xl69" align="right">
              262639
            </td>
            <td className="xl70">0.32</td>
            <td className="xl70">0.32</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Reunion Island-Mobile
            </td>
            <td className="xl66" align="right">
              262692
            </td>
            <td className="xl67">0.32</td>
            <td className="xl67">0.32</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Romania
            </td>
            <td className="xl69" align="right">
              40
            </td>
            <td className="xl70">0.14</td>
            <td className="xl70">0.14</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Romania-Bucharest
            </td>
            <td className="xl66" align="right">
              4021
            </td>
            <td className="xl67">0.11</td>
            <td className="xl67">0.11</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Romania-Mobile
            </td>
            <td className="xl69" align="right">
              407
            </td>
            <td className="xl70">0.32</td>
            <td className="xl70">0.32</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Romania-Mobile Cosmorom
            </td>
            <td className="xl66" align="right">
              4076
            </td>
            <td className="xl67">0.32</td>
            <td className="xl67">0.32</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Romania-Mobile Orange
            </td>
            <td className="xl69" align="right">
              4075
            </td>
            <td className="xl70">0.32</td>
            <td className="xl70">0.32</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Romania-Mobile Orange
            </td>
            <td className="xl66" align="right">
              4074
            </td>
            <td className="xl67">0.32</td>
            <td className="xl67">0.32</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Romania-Mobile Telemobil
            </td>
            <td className="xl69" align="right">
              4078
            </td>
            <td className="xl70">0.32</td>
            <td className="xl70">0.32</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Romania-Mobile Vodafone
            </td>
            <td className="xl66" align="right">
              4072
            </td>
            <td className="xl67">0.32</td>
            <td className="xl67">0.32</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Russia
            </td>
            <td className="xl69" align="right">
              7
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Russia,Globaltel Satellite
            </td>
            <td className="xl66" align="right">
              7954
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Russia,Outer St. Petersburg
            </td>
            <td className="xl69" align="right">
              78126
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Russia-1
            </td>
            <td className="xl66" align="right">
              7336
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Russia-2
            </td>
            <td className="xl69" align="right">
              73012
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Russia-3
            </td>
            <td className="xl66" align="right">
              7424
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Russia-Mobile
            </td>
            <td className="xl69" align="right">
              79
            </td>
            <td className="xl70">0.1</td>
            <td className="xl70">0.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Russia-Moscow
            </td>
            <td className="xl66" align="right">
              7495
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Russia-Moscow Suburb
            </td>
            <td className="xl69" align="right">
              7096
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Russia-Rostovdon
            </td>
            <td className="xl66" align="right">
              78632
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Russia-St. Petersburg
            </td>
            <td className="xl69" align="right">
              7812
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Rwanda
            </td>
            <td className="xl66" align="right">
              250
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Rwanda-Mobile
            </td>
            <td className="xl69" align="right">
              25005
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              San Marino
            </td>
            <td className="xl66" align="right">
              378
            </td>
            <td className="xl67">0.06</td>
            <td className="xl67">0.06</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Sao Tome
            </td>
            <td className="xl69" align="right">
              239
            </td>
            <td className="xl70">1.12</td>
            <td className="xl70">1.12</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Saudi Arabia
            </td>
            <td className="xl66" align="right">
              966
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Saudi Arabia-Dhahran
            </td>
            <td className="xl69" align="right">
              9663
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Saudi Arabia-Jeddah
            </td>
            <td className="xl66" align="right">
              96622
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Saudi Arabia-Jeddah Mecca
            </td>
            <td className="xl69" align="right">
              96625
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Saudi Arabia-Mobile
            </td>
            <td className="xl66" align="right">
              9665
            </td>
            <td className="xl67">0.26</td>
            <td className="xl67">0.26</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Saudi Arabia-Riyadh
            </td>
            <td className="xl69" align="right">
              96612
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Senegal Republic
            </td>
            <td className="xl66" align="right">
              221
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Senegal Republic Mobile Orange
            </td>
            <td className="xl69" align="right">
              22177
            </td>
            <td className="xl70">0.26</td>
            <td className="xl70">0.26</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Senegal Republic-Cell Tigo
            </td>
            <td className="xl66" align="right">
              22176
            </td>
            <td className="xl67">0.26</td>
            <td className="xl67">0.26</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Senegal Republic-Dakar
            </td>
            <td className="xl69" align="right">
              2218
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Senegal Republic-Mobile
            </td>
            <td className="xl66" align="right">
              2216
            </td>
            <td className="xl67">0.26</td>
            <td className="xl67">0.26</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Serbia
            </td>
            <td className="xl69" align="right">
              381
            </td>
            <td className="xl70">0.12</td>
            <td className="xl70">0.12</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Serbia-Belgrade
            </td>
            <td className="xl66" align="right">
              38111
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Serbia-Mobile
            </td>
            <td className="xl69" align="right">
              3816
            </td>
            <td className="xl70">0.27</td>
            <td className="xl70">0.27</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Serbia-Mobile Mobtel
            </td>
            <td className="xl66" align="right">
              38163
            </td>
            <td className="xl67">0.27</td>
            <td className="xl67">0.27</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Serbia-Mobile Mts
            </td>
            <td className="xl69" align="right">
              38164
            </td>
            <td className="xl70">0.31</td>
            <td className="xl70">0.31</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Serbia-Montenegro
            </td>
            <td className="xl66" align="right">
              3818
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Seychelles Islands
            </td>
            <td className="xl69" align="right">
              248
            </td>
            <td className="xl70">0.28</td>
            <td className="xl70">0.28</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Sierra Leone
            </td>
            <td className="xl66" align="right">
              232
            </td>
            <td className="xl67">0.4</td>
            <td className="xl67">0.4</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Sierra Leone-Freetown
            </td>
            <td className="xl69" align="right">
              23222
            </td>
            <td className="xl70">0.4</td>
            <td className="xl70">0.4</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Sierra Leone-Mobile
            </td>
            <td className="xl66" align="right">
              23223
            </td>
            <td className="xl67">0.4</td>
            <td className="xl67">0.4</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Singapore
            </td>
            <td className="xl69" align="right">
              65
            </td>
            <td className="xl70">0.04</td>
            <td className="xl70">0.04</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Singapore-Mobile
            </td>
            <td className="xl66" align="right">
              659
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Slovakia
            </td>
            <td className="xl69" align="right">
              421
            </td>
            <td className="xl70">0.08</td>
            <td className="xl70">0.08</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Slovakia-Mobile
            </td>
            <td className="xl66" align="right">
              4219
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Slovenia
            </td>
            <td className="xl69" align="right">
              386
            </td>
            <td className="xl70">0.08</td>
            <td className="xl70">0.08</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Slovenia-Mobile
            </td>
            <td className="xl66" align="right">
              38640
            </td>
            <td className="xl67">0.37</td>
            <td className="xl67">0.37</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Solomon Islands
            </td>
            <td className="xl69" align="right">
              677
            </td>
            <td className="xl70">1.17</td>
            <td className="xl70">1.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Somalia
            </td>
            <td className="xl66" align="right">
              252
            </td>
            <td className="xl67">0.55</td>
            <td className="xl67">0.55</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Somalia Premium
            </td>
            <td className="xl69" align="right">
              25240
            </td>
            <td className="xl70">0.55</td>
            <td className="xl70">0.55</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              South Africa
            </td>
            <td className="xl66" align="right">
              27
            </td>
            <td className="xl67">0.08</td>
            <td className="xl67">0.08</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              South Africa Value Added Network
            </td>
            <td className="xl69" align="right">
              2710001
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              South Africa-Cell Other
            </td>
            <td className="xl66" align="right">
              27811
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              South Africa-Cellular-Cell C
            </td>
            <td className="xl69" align="right">
              2774
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              South Africa-Cellular-Mtn
            </td>
            <td className="xl66" align="right">
              2773
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              South Africa-Cellular-Vodacom
            </td>
            <td className="xl69" align="right">
              27711
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              South Africa-Johannesburg
            </td>
            <td className="xl66" align="right">
              2711
            </td>
            <td className="xl67">0.08</td>
            <td className="xl67">0.08</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              South Korea
            </td>
            <td className="xl69" align="right">
              82
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              South Korea-Mobile
            </td>
            <td className="xl66" align="right">
              821
            </td>
            <td className="xl67">0.08</td>
            <td className="xl67">0.08</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              South Korea-Seoul
            </td>
            <td className="xl69" align="right">
              822
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              South Sudan
            </td>
            <td className="xl66" align="right">
              211
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Spain
            </td>
            <td className="xl69" align="right">
              34
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Spain Cellular-Telefonica
            </td>
            <td className="xl66" align="right">
              34699
            </td>
            <td className="xl67">0.3</td>
            <td className="xl67">0.3</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Spain-Barcelona
            </td>
            <td className="xl69" align="right">
              3493
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Spain-Madrid
            </td>
            <td className="xl66" align="right">
              3491
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Spain-Mobile
            </td>
            <td className="xl69" align="right">
              346
            </td>
            <td className="xl70">0.3</td>
            <td className="xl70">0.3</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Spain-Special
            </td>
            <td className="xl66" align="right">
              341248
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Sri Lanka
            </td>
            <td className="xl69" align="right">
              94
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Sri Lanka,Colombo Slt
            </td>
            <td className="xl66" align="right">
              94112
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Sri Lanka,Slt
            </td>
            <td className="xl69" align="right">
              94212
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Sri Lanka-Mobile Celltel
            </td>
            <td className="xl66" align="right">
              9472
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Sri Lanka-Mobile Dialog
            </td>
            <td className="xl69" align="right">
              9477
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Sri Lanka-Mobile Hutchinson
            </td>
            <td className="xl66" align="right">
              9478
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Sri Lanka-Mobile Mobi Tel
            </td>
            <td className="xl69" align="right">
              9471
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              St. Helena
            </td>
            <td className="xl66" align="right">
              290
            </td>
            <td className="xl67">0.69</td>
            <td className="xl67">0.69</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              St. Kitts
            </td>
            <td className="xl69" align="right">
              1869
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              St. Kitts-C&amp;W Mobile
            </td>
            <td className="xl66" align="right">
              1869662
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              St. Kitts-Mobile
            </td>
            <td className="xl69" align="right">
              1869556
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              St. Lucia
            </td>
            <td className="xl66" align="right">
              1758
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              St. Lucia-C&amp;W Mobile
            </td>
            <td className="xl69" align="right">
              1758284
            </td>
            <td className="xl70">0.28</td>
            <td className="xl70">0.28</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              St. Lucia-Mobile
            </td>
            <td className="xl66" align="right">
              1758518
            </td>
            <td className="xl67">0.28</td>
            <td className="xl67">0.28</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              St. Pierre &amp; Miquelon
            </td>
            <td className="xl69" align="right">
              508
            </td>
            <td className="xl70">0.16</td>
            <td className="xl70">0.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              St. Vincent
            </td>
            <td className="xl66" align="right">
              1784
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              St. Vincent-C&amp;W Mobile
            </td>
            <td className="xl69" align="right">
              1784454
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              St. Vincent-Mobile
            </td>
            <td className="xl66" align="right">
              1784430
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Sudan
            </td>
            <td className="xl69" align="right">
              249
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Sudan Cellular-Areeba
            </td>
            <td className="xl66" align="right">
              24992
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Sudan Cellular-Kabartel
            </td>
            <td className="xl69" align="right">
              24915
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Sudan Cellular-Sudatel
            </td>
            <td className="xl66" align="right">
              24912
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Sudan Cellular-Vivacel
            </td>
            <td className="xl69" align="right">
              24995
            </td>
            <td className="xl70">0.21</td>
            <td className="xl70">0.21</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Sudan Mobile
            </td>
            <td className="xl66" align="right">
              2499
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Suriname
            </td>
            <td className="xl69" align="right">
              597
            </td>
            <td className="xl70">0.28</td>
            <td className="xl70">0.28</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Suriname-Mobile
            </td>
            <td className="xl66" align="right">
              5978
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Swaziland
            </td>
            <td className="xl69" align="right">
              268
            </td>
            <td className="xl70">0.12</td>
            <td className="xl70">0.12</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Swaziland-Mobile
            </td>
            <td className="xl66" align="right">
              26860
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Sweden
            </td>
            <td className="xl69" align="right">
              46
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Sweden-Mobile
            </td>
            <td className="xl66" align="right">
              4610
            </td>
            <td className="xl67">0.24</td>
            <td className="xl67">0.24</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Sweden-Stockholm
            </td>
            <td className="xl69" align="right">
              468
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Switzerland
            </td>
            <td className="xl66" align="right">
              41
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Switzerland-Celluar Swisscom
            </td>
            <td className="xl69" align="right">
              41774
            </td>
            <td className="xl70">0.32</td>
            <td className="xl70">0.32</td>
            <td className="xl69">peak</td>
          </tr>

          <tr>
            <td className="xl66" height="17">
              Switzerland-Cellular Orange
            </td>
            <td className="xl66" align="right">
              4178
            </td>
            <td className="xl67">0.32</td>
            <td className="xl67">0.32</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Switzerland-Cellular Sunrise
            </td>
            <td className="xl69" align="right">
              4176
            </td>
            <td className="xl70">0.32</td>
            <td className="xl70">0.32</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Switzerland-Mobile
            </td>
            <td className="xl66" align="right">
              417
            </td>
            <td className="xl67">0.32</td>
            <td className="xl67">0.32</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Syria
            </td>
            <td className="xl69" align="right">
              963
            </td>
            <td className="xl70">0.34</td>
            <td className="xl70">0.34</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Syria-Mobile
            </td>
            <td className="xl66" align="right">
              9639
            </td>
            <td className="xl67">0.34</td>
            <td className="xl67">0.34</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Taiwan
            </td>
            <td className="xl69" align="right">
              886
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Taiwan-Mobile
            </td>
            <td className="xl66" align="right">
              8869
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Taiwan-Taipei
            </td>
            <td className="xl69" align="right">
              8862
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Tajikistan
            </td>
            <td className="xl66" align="right">
              992
            </td>
            <td className="xl67">0.18</td>
            <td className="xl67">0.18</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Tajikistan-Dushanbe
            </td>
            <td className="xl69" align="right">
              992372
            </td>
            <td className="xl70">0.18</td>
            <td className="xl70">0.18</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Tajikistan-Mobile
            </td>
            <td className="xl66" align="right">
              9929
            </td>
            <td className="xl67">0.18</td>
            <td className="xl67">0.18</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Tanzania
            </td>
            <td className="xl69" align="right">
              255
            </td>
            <td className="xl70">0.26</td>
            <td className="xl70">0.26</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Tanzania-Dar Es Salaam
            </td>
            <td className="xl66" align="right">
              25522
            </td>
            <td className="xl67">0.21</td>
            <td className="xl67">0.21</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Tanzania-Mobile
            </td>
            <td className="xl69" align="right">
              25574
            </td>
            <td className="xl70">0.24</td>
            <td className="xl70">0.24</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Thailand
            </td>
            <td className="xl66" align="right">
              66
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Thailand-Bangkok
            </td>
            <td className="xl69" align="right">
              662
            </td>
            <td className="xl70">0.07</td>
            <td className="xl70">0.07</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Thailand-Mobile
            </td>
            <td className="xl66" align="right">
              668
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Togo
            </td>
            <td className="xl69" align="right">
              228
            </td>
            <td className="xl70">0.19</td>
            <td className="xl70">0.19</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Togo Mobile-Togocel
            </td>
            <td className="xl66" align="right">
              22806
            </td>
            <td className="xl67">0.19</td>
            <td className="xl67">0.19</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Togo-Mobile
            </td>
            <td className="xl69" align="right">
              2289
            </td>
            <td className="xl70">0.19</td>
            <td className="xl70">0.19</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Tokelau
            </td>
            <td className="xl66" align="right">
              690
            </td>
            <td className="xl67">0.75</td>
            <td className="xl67">0.75</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Tonga Islands
            </td>
            <td className="xl69" align="right">
              676
            </td>
            <td className="xl70">0.35</td>
            <td className="xl70">0.35</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Trinidad
            </td>
            <td className="xl66" align="right">
              1868
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Trinidad Cellular-Other
            </td>
            <td className="xl69" align="right">
              186835
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Trinidad Tstt Cellular
            </td>
            <td className="xl66" align="right">
              186846
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Trinidad Tstt Cellular 186868
            </td>
            <td className="xl69" align="right">
              186868
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Tunisia
            </td>
            <td className="xl66" align="right">
              216
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Tunisia-Mobile
            </td>
            <td className="xl69" align="right">
              2169
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Tunisia-Mobile-Tunisiana
            </td>
            <td className="xl66" align="right">
              2162
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Turkey
            </td>
            <td className="xl69" align="right">
              90
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Turkey Mobile-Vodafone Northern Cyprus
            </td>
            <td className="xl66" align="right">
              905428
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Turkey-Adana
            </td>
            <td className="xl69" align="right">
              90322
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Turkey-Ankara
            </td>
            <td className="xl66" align="right">
              90312
            </td>
            <td className="xl67">0.15</td>
            <td className="xl67">0.15</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Turkey-Antalya
            </td>
            <td className="xl69" align="right">
              90242
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Turkey-Istanbul
            </td>
            <td className="xl66" align="right">
              90212
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Turkey-Izmir
            </td>
            <td className="xl69" align="right">
              90232
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Turkey-Mobile
            </td>
            <td className="xl66" align="right">
              905
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Turkey-Mobile Aria
            </td>
            <td className="xl69" align="right">
              9055
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Turkey-Mobile Ay
            </td>
            <td className="xl66" align="right">
              9050
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Turkey-Mobile Turkcell
            </td>
            <td className="xl69" align="right">
              9053
            </td>
            <td className="xl70">0.28</td>
            <td className="xl70">0.28</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Turkey-Mobile Vodafone
            </td>
            <td className="xl66" align="right">
              9054
            </td>
            <td className="xl67">0.2</td>
            <td className="xl67">0.2</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Turkey-North Cyprus
            </td>
            <td className="xl69" align="right">
              90392
            </td>
            <td className="xl70">0.15</td>
            <td className="xl70">0.15</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Turkmenistan
            </td>
            <td className="xl66" align="right">
              993
            </td>
            <td className="xl67">0.19</td>
            <td className="xl67">0.19</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Turks &amp; Caicos
            </td>
            <td className="xl69" align="right">
              1649
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Turks &amp; Caicos C&amp;W Cellular
            </td>
            <td className="xl66" align="right">
              1649231
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Turks &amp; Caicos Cellular
            </td>
            <td className="xl69" align="right">
              1649331
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Tuvalu
            </td>
            <td className="xl66" align="right">
              688
            </td>
            <td className="xl67">0.85</td>
            <td className="xl67">0.85</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Uganda
            </td>
            <td className="xl69" align="right">
              256
            </td>
            <td className="xl70">0.12</td>
            <td className="xl70">0.12</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Uganda Mobile Celtel
            </td>
            <td className="xl66" align="right">
              25675
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Uganda Mobile-Gemtel
            </td>
            <td className="xl69" align="right">
              256477
            </td>
            <td className="xl70">0.12</td>
            <td className="xl70">0.12</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Uganda Mobile-Itel Telecom
            </td>
            <td className="xl66" align="right">
              256760
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Uganda Mobile-Mtn
            </td>
            <td className="xl69" align="right">
              25639
            </td>
            <td className="xl70">0.12</td>
            <td className="xl70">0.12</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Uganda Mobile-Orange
            </td>
            <td className="xl66" align="right">
              25679
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Uganda Mobile-Utl
            </td>
            <td className="xl69" align="right">
              25671
            </td>
            <td className="xl70">0.12</td>
            <td className="xl70">0.12</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Uganda Mobile-Warid
            </td>
            <td className="xl66" align="right">
              25670
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ukraine
            </td>
            <td className="xl69" align="right">
              380
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ukraine Mobile Astelit
            </td>
            <td className="xl66" align="right">
              38063
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ukraine Mobile Kievstar
            </td>
            <td className="xl69" align="right">
              38067
            </td>
            <td className="xl70">0.16</td>
            <td className="xl70">0.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ukraine Mobile Mts
            </td>
            <td className="xl66" align="right">
              38050
            </td>
            <td className="xl67">0.16</td>
            <td className="xl67">0.16</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ukraine-Dnipropetrovsk
            </td>
            <td className="xl69" align="right">
              380562
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ukraine-Kiev
            </td>
            <td className="xl66" align="right">
              38045
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ukraine-Krivoi Rog
            </td>
            <td className="xl69" align="right">
              380564
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ukraine-Lviv
            </td>
            <td className="xl66" align="right">
              380322
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ukraine-Mobile
            </td>
            <td className="xl69" align="right">
              38068
            </td>
            <td className="xl70">0.16</td>
            <td className="xl70">0.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ukraine-Odessa
            </td>
            <td className="xl66" align="right">
              38048
            </td>
            <td className="xl67">0.1</td>
            <td className="xl67">0.1</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Ukraine-Sevastopol
            </td>
            <td className="xl69" align="right">
              380692
            </td>
            <td className="xl70">0.13</td>
            <td className="xl70">0.13</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Ukraine-Simferolpol
            </td>
            <td className="xl66" align="right">
              380652
            </td>
            <td className="xl67">0.13</td>
            <td className="xl67">0.13</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              United Arab Emirates
            </td>
            <td className="xl69" align="right">
              971
            </td>
            <td className="xl70">0.26</td>
            <td className="xl70">0.26</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              United Arab Emirates-Mobile
            </td>
            <td className="xl66" align="right">
              97150
            </td>
            <td className="xl67">0.26</td>
            <td className="xl67">0.26</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              United Kingdom
            </td>
            <td className="xl69" align="right">
              44
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              United Kingdom Special Services
            </td>
            <td className="xl66" align="right">
              448
            </td>
            <td className="xl67">0.199</td>
            <td className="xl67">0.199</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              United Kingdom-London
            </td>
            <td className="xl69" align="right">
              44207
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              United Kingdom-Mobile
            </td>
            <td className="xl66" align="right">
              447
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              United Kingdom-Mobile Pns
            </td>
            <td className="xl69" align="right">
              4470
            </td>
            <td className="xl70">0.22</td>
            <td className="xl70">0.22</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              United Kingdom-Mobile-H3g
            </td>
            <td className="xl66" align="right">
              447723
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              United Kingdom-Mobile-O2
            </td>
            <td className="xl69" align="right">
              447701
            </td>
            <td className="xl70">0.22</td>
            <td className="xl70">0.22</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              United Kingdom-Mobile-Orange
            </td>
            <td className="xl66" align="right">
              447773
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              United Kingdom-Mobile-Tmobile
            </td>
            <td className="xl69" align="right">
              447903
            </td>
            <td className="xl70">0.22</td>
            <td className="xl70">0.22</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              United Kingdom-Mobile-Vodafone
            </td>
            <td className="xl66" align="right">
              447721
            </td>
            <td className="xl67">0.22</td>
            <td className="xl67">0.22</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              United Kingdom-Premium
            </td>
            <td className="xl69" align="right">
              449
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Uruguay
            </td>
            <td className="xl66" align="right">
              598
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Uruguay-Mobile
            </td>
            <td className="xl69" align="right">
              5989
            </td>
            <td className="xl70">0.25</td>
            <td className="xl70">0.25</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Uruguay-Montevideo
            </td>
            <td className="xl66" align="right">
              5982
            </td>
            <td className="xl67">0.12</td>
            <td className="xl67">0.12</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Us
            </td>
            <td className="xl69" align="right">
              1
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Us Tollfree
            </td>
            <td className="xl66" align="right">
              1800
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Us Tollfree-Customer Service
            </td>
            <td className="xl69" align="right">
              18884713673
            </td>
            <td className="xl70">0.05</td>
            <td className="xl70">0.05</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Us Virgin Islands
            </td>
            <td className="xl66" align="right">
              1340
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Us-1900 C+W Cayman
            </td>
            <td className="xl69" align="right">
              1900222
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Us-Ak-907 (Alaska)
            </td>
            <td className="xl66" align="right">
              1907
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Us-C+W Toll Free
            </td>
            <td className="xl69" align="right">
              1800744
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Us-Directory Asst
            </td>
            <td className="xl66" align="right">
              1201555
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Us-Hi-808 (Hawaii)
            </td>
            <td className="xl69" align="right">
              1808
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Us-Nyc
            </td>
            <td className="xl66" align="right">
              1212
            </td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Us-Texas
            </td>
            <td className="xl69" align="right">
              1210
            </td>
            <td className="xl70">Blocked</td>
            <td className="xl70">Blocked</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Usa-Nj-201 Ad
            </td>
            <td className="xl66">*221201</td>
            <td className="xl67">Blocked</td>
            <td className="xl67">Blocked</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Uzbekistan
            </td>
            <td className="xl69" align="right">
              998
            </td>
            <td className="xl70">0.11</td>
            <td className="xl70">0.11</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Uzbekistan-Mobile
            </td>
            <td className="xl66" align="right">
              9989
            </td>
            <td className="xl67">0.11</td>
            <td className="xl67">0.11</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Vanuatu Republic
            </td>
            <td className="xl69" align="right">
              678
            </td>
            <td className="xl70">0.91</td>
            <td className="xl70">0.91</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Vatican City
            </td>
            <td className="xl66" align="right">
              379
            </td>
            <td className="xl67">0.05</td>
            <td className="xl67">0.05</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Venezuela
            </td>
            <td className="xl69" align="right">
              58
            </td>
            <td className="xl70">0.08</td>
            <td className="xl70">0.08</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Venezuela Mobile Telcel
            </td>
            <td className="xl66" align="right">
              58414
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Venezuela-Caracas
            </td>
            <td className="xl69" align="right">
              58212
            </td>
            <td className="xl70">0.06</td>
            <td className="xl70">0.06</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Venezuela-Mobile
            </td>
            <td className="xl66" align="right">
              58418
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Venezuela-Mobile Tim Digitel
            </td>
            <td className="xl69" align="right">
              58412
            </td>
            <td className="xl70">0.23</td>
            <td className="xl70">0.23</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Venezuela-Mobile-Movilnet
            </td>
            <td className="xl66" align="right">
              58416
            </td>
            <td className="xl67">0.23</td>
            <td className="xl67">0.23</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Venezuela-Valencia
            </td>
            <td className="xl69" align="right">
              58241
            </td>
            <td className="xl70">0.08</td>
            <td className="xl70">0.08</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Vietnam
            </td>
            <td className="xl66" align="right">
              84
            </td>
            <td className="xl67">0.32</td>
            <td className="xl67">0.32</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Vietnam-Mobile
            </td>
            <td className="xl69" align="right">
              849
            </td>
            <td className="xl70">0.33</td>
            <td className="xl70">0.33</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Voiceline Backend Processing
            </td>
            <td className="xl66">*0009</td>
            <td className="xl67">0</td>
            <td className="xl67">0</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Wallis &amp; Futuna
            </td>
            <td className="xl69" align="right">
              681
            </td>
            <td className="xl70">1.1</td>
            <td className="xl70">1.1</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Western Samoa
            </td>
            <td className="xl66" align="right">
              685
            </td>
            <td className="xl67">0.52</td>
            <td className="xl67">0.52</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Yemen
            </td>
            <td className="xl69" align="right">
              967
            </td>
            <td className="xl70">0.17</td>
            <td className="xl70">0.17</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Yemen-Mobile
            </td>
            <td className="xl66" align="right">
              96771
            </td>
            <td className="xl67">0.17</td>
            <td className="xl67">0.17</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Zambia
            </td>
            <td className="xl69" align="right">
              260
            </td>
            <td className="xl70">0.11</td>
            <td className="xl70">0.11</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Zambia-Mobile
            </td>
            <td className="xl66" align="right">
              26095
            </td>
            <td className="xl67">0.27</td>
            <td className="xl67">0.27</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Zanzibar
            </td>
            <td className="xl69" align="right">
              259
            </td>
            <td className="xl70">1.16</td>
            <td className="xl70">1.16</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Zimbabwe
            </td>
            <td className="xl66" align="right">
              263
            </td>
            <td className="xl67">0.09</td>
            <td className="xl67">0.09</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Zimbabwe Mobil-Telecel
            </td>
            <td className="xl69" align="right">
              26323
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
          <tr>
            <td className="xl66" height="17">
              Zimbabwe-Mobile Econet
            </td>
            <td className="xl66" align="right">
              26391
            </td>
            <td className="xl67">0.25</td>
            <td className="xl67">0.25</td>
            <td className="xl66">peak</td>
          </tr>
          <tr>
            <td className="xl69" height="17">
              Zimbabwe-Mobile Netone
            </td>
            <td className="xl69" align="right">
              26311
            </td>
            <td className="xl70">0.2</td>
            <td className="xl70">0.2</td>
            <td className="xl69">peak</td>
          </tr>
        </tbody>
      </table>
    </Main>
  );
}
